(function () {
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        // Don't initialize anything in constructor - element might not be in DOM yet
        this._cutoffTimer = null;
      }

      connectedCallback() {
        // Initialize all properties when element is in DOM
        this.productParentElement = this.closest(`[data-section][data-product]`);

        if (this.productParentElement) {
          this.dataset.section = this.productParentElement.dataset.section;
          this.dataset.product = this.productParentElement.dataset.product;
        }

        this.form = this.querySelector("form");
        if (this.form) {
          const idInput = this.form.querySelector('[name="id"]');
          if (idInput) {
            idInput.disabled = false;
          }

          // Remove old listener if exists
          if (this._submitHandler) {
            this.form.removeEventListener("submit", this._submitHandler);
          }

          // Add new listener
          this._submitHandler = this.onSubmitHandler.bind(this);
          this.form.addEventListener("submit", this._submitHandler);
        }

        this.informationModal = document.querySelector("information-modal");

        // Find all add to cart buttons: main form buttons and sticky buttons
        if (this.productParentElement) {
          const mainButtons = this.productParentElement.querySelectorAll(
            'product-buttons [type="submit"]'
          );
          const stickyButtons = this.productParentElement.querySelectorAll(
            'sticky-atc [type="submit"]'
          );
          this.atcButtons = [...mainButtons, ...stickyButtons];
        }

        this.updateCutoffDispatchMessage();
        this._cutoffTimer = setInterval(() => {
          this.updateCutoffDispatchMessage();
        }, 60000);

        Shopify?.PaymentButton?.init();
      }

      disconnectedCallback() {
        if (this._submitHandler && this.form) {
          this.form.removeEventListener("submit", this._submitHandler);
        }

        if (this._cutoffTimer) {
          clearInterval(this._cutoffTimer);
          this._cutoffTimer = null;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.productParentElement.dataset.variantSelected === "false") {
          const submitter = evt.submitter || evt.submitterPolyfill;

          this.handleErrorMessage(window.variantStrings.selectVariant);
          return;
        }

        // Check if the current selection should block add to cart.
        const productButtons = this.productParentElement.querySelector("product-buttons");
        const variantRadios = this.productParentElement.querySelector("variant-radios");

        const availabilityState = productButtons?.getAttribute("availability");
        if (availabilityState === "unavailable") {
          const unavailableMessage =
            window.variantStrings?.combinationUnavailable ||
            window.variantStrings?.unavailable ||
            "This combination is unavailable";
          this.handleErrorMessage(unavailableMessage);
          return;
        }

        if (availabilityState === "sold-out") {
          const soldOutMessage =
            window.variantStrings?.outOfStock ||
            window.variantStrings?.soldOut ||
            "Out of stock";
          this.handleErrorMessage(soldOutMessage);
          return;
        }

        // Also check if variant-radios has a null currentVariant (combination doesn't exist)
        if (variantRadios) {
          const hasSelectedVariantGetter = typeof variantRadios.getSelectedVariant === "function";
          const hasVariantGetter = typeof variantRadios.getCurrentVariant === "function";
          const hasCurrentVariantProp = "currentVariant" in variantRadios;
          const selectedVariant = hasSelectedVariantGetter
            ? variantRadios.getSelectedVariant()
            : null;
          const currentVariant = selectedVariant
            || (hasVariantGetter
              ? variantRadios.getCurrentVariant()
              : hasCurrentVariantProp
                ? variantRadios.currentVariant
                : null);

          // Only block if variant-radios actually provides variant state.
          // Some templates include <variant-radios> but manage selection elsewhere.
          if ((hasSelectedVariantGetter || hasVariantGetter || hasCurrentVariantProp) && !currentVariant) {
            const unavailableMessage =
              window.variantStrings?.combinationUnavailable ||
              window.variantStrings?.unavailable ||
              "This combination is unavailable";
            this.handleErrorMessage(unavailableMessage);
            return;
          }
        }

        this.handleAtcButtonStates("loading");

        this.handleErrorMessage();

        // redeclare form to gather updater inputs
        this.form = this.querySelector("form");

        const formData = new FormData(this.form);

        this.dynamicSectionsNodes = document.querySelectorAll("cart-dynamic");

        let dynamicSections = [];
        if (this.dynamicSectionsNodes) {
          dynamicSections = [...this.dynamicSectionsNodes].map(
            (item) => item.dataset.sectionId
          );
        }

        // unique dynamic sections
        dynamicSections = [...new Set(dynamicSections)];

        formData.append("sections", dynamicSections.join(","));

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              let errorMessage = "";
              // if response description is a string
              if (typeof response.description === "string") {
                errorMessage = response.description;
              } else {
                Object.keys(response.description).forEach((key) => {
                  if (key !== "status" && key !== "sections") {
                    errorMessage += `${response.description[key]}\n`;
                  }
                });
              }

              this.handleErrorMessage(errorMessage);
              this.handleAtcButtonStates("error");
              // this.productParentElement.dataset.variantSelected = false;
              return;
            }

            // update dynamic sections
            this.dynamicSectionsNodes.forEach((node) => {
              const htmlString = response.sections[node.dataset.sectionId];
              const html = new DOMParser().parseFromString(
                htmlString,
                "text/html"
              );
              node.innerHTML = html.querySelector(
                `cart-dynamic[data-section-id='${node.dataset.sectionId}']`
              ).innerHTML;
              node.classList = html.querySelector(
                `cart-dynamic[data-section-id='${node.dataset.sectionId}']`
              ).classList;
              node.modified();
            });

            this.handleAtcButtonStates("success");

            // Dispatch cart:added event to trigger cart drawer
            document.dispatchEvent(new CustomEvent('cart:added', {
              bubbles: true,
              detail: {
                source: 'product-form',
                product: response
              }
            }));
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {});
      }

      handleAtcButtonStates(state) {
        this.atcButtons.forEach((button) => {
          switch (state) {
            case "loading":
              if (button.dataset.state == "loading") return;
              button.setAttribute("aria-disabled", true);
              button.dataset.state = "loading";
              break;

            case "error":
              button.dataset.state = "error";
              button.removeAttribute("aria-disabled");
              navigator.vibrate?.(100);
              setTimeout(() => button.removeAttribute("data-state"), 3000);
              break;

            case "success":
              // Don't show success state, just reset to default
              button.removeAttribute("data-state");
              button.removeAttribute("aria-disabled");
              navigator.vibrate?.(100);
              break;
          }
        });
      }
      handleStickySubmit(submitter) {
        if (submitter.closest("sticky-mobile")) {
          const mobileFormDrawer = this.productParentElement.querySelector(
            `drawer-element[id^="product-form-template"]`
          );
          mobileFormDrawer.openDrawer();
          return;
        }

        if (submitter.closest("sticky-desktop")) {
          const variantSelector = submitter
            .closest("sticky-desktop")
            .querySelector(".variant-selector");
          variantSelector.classList.add(
            "outline-offset-2",
            "outline-2",
            "outline-highlight-red"
          );
          variantSelector.addEventListener("click", () => {
            variantSelector.classList.remove(
              "outline-offset-2",
              "outline-2",
              "outline-highlight-red"
            );
          });
          return;
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrappers =
          this.errorMessageWrappers ||
          this.productParentElement.querySelectorAll("error-message");

        this.errorMessageWrappers.forEach((errorMessageWrapper) => {
          if (errorMessage) {
            const errorMessageOutput =
              errorMessageWrapper.querySelector("span");
            errorMessageOutput.textContent = errorMessage;
            errorMessageWrapper.classList.remove("hidden");
            setTimeout(() => {
              errorMessageWrapper.classList.add("hidden");
            }, 3000);
          } else {
            errorMessageWrapper.classList.add("hidden");
          }
        });
      }

      updateCutoffDispatchMessage() {
        const dispatchMessageNode = this.querySelector("[data-cutoff-dispatch]");
        if (!dispatchMessageNode) return;
        const skeletonNode = dispatchMessageNode.querySelector("[data-cutoff-skeleton]");
        const textNode = dispatchMessageNode.querySelector("[data-cutoff-text]");

        const revealCutoffMessage = () => {
          dispatchMessageNode.dataset.cutoffReady = "true";
          skeletonNode?.classList.add("hidden");
          textNode?.classList.remove("hidden");
        };

        const cutoffRange = dispatchMessageNode.dataset.cutoffRange || "";
        const remainingTemplate = dispatchMessageNode.dataset.cutoffTemplate || "";
        const rangeMatch = cutoffRange.match(/^(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/);

        if (!rangeMatch || !remainingTemplate.includes("__REMAINING__")) {
          revealCutoffMessage();
          return;
        }

        const startHour = Number(rangeMatch[1]);
        const startMinute = Number(rangeMatch[2]);
        const endHour = Number(rangeMatch[3]);
        const endMinute = Number(rangeMatch[4]);

        if (
          Number.isNaN(startHour) || Number.isNaN(startMinute) ||
          Number.isNaN(endHour) || Number.isNaN(endMinute) ||
          startHour > 23 || endHour > 23 || startMinute > 59 || endMinute > 59
        ) {
          revealCutoffMessage();
          return;
        }

        const startTotalMinutes = (startHour * 60) + startMinute;
        const endTotalMinutes = (endHour * 60) + endMinute;
        const now = new Date();
        const nowTotalMinutes = (now.getHours() * 60) + now.getMinutes();

        const isOvernightRange = endTotalMinutes <= startTotalMinutes;
        const isInRange = isOvernightRange
          ? nowTotalMinutes >= startTotalMinutes || nowTotalMinutes < endTotalMinutes
          : nowTotalMinutes >= startTotalMinutes && nowTotalMinutes < endTotalMinutes;

        if (!isInRange) {
          revealCutoffMessage();
          return;
        }

        let remainingMinutes = 0;
        if (isOvernightRange && nowTotalMinutes >= startTotalMinutes) {
          remainingMinutes = (24 * 60) - nowTotalMinutes + endTotalMinutes;
        } else {
          remainingMinutes = endTotalMinutes - nowTotalMinutes;
        }

        if (remainingMinutes <= 0) {
          revealCutoffMessage();
          return;
        }

        const hours = Math.floor(remainingMinutes / 60);
        const minutes = remainingMinutes % 60;

        let remainingText = "";
        if (hours > 0 && minutes > 0) {
          remainingText = `${hours}h ${minutes}m`;
        } else if (hours > 0) {
          remainingText = `${hours}h`;
        } else {
          remainingText = `${minutes}m`;
        }

        if (textNode) {
          textNode.innerHTML = remainingTemplate.replace("__REMAINING__", remainingText);
        }
        revealCutoffMessage();
      }
    }
  );
}

// Klaviyo Waitlist Form Handler
if (!customElements.get("klaviyo-waitlist-form")) {
  customElements.define(
    "klaviyo-waitlist-form",
    class KlaviyoWaitlistForm extends HTMLFormElement {
      constructor() {
        super();
        this.variantInput = null;
      }

      connectedCallback() {
        this.addEventListener("submit", this.onSubmit.bind(this));
        // Find the hidden variant ID input from the main product form
        this.variantInput = document.querySelector('product-form input[name="id"]');
      }

      async onSubmit(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling to parent form
        e.stopImmediatePropagation(); // Ensure no other handlers are called
        
        const submitButton = this.querySelector('button[type="submit"]');
        const emailInput = this.querySelector("#klaviyo-waitlist-email");
        
        if (!emailInput.value || !this.variantInput || !this.variantInput.value) {
          this.fail("Missing email or variant information");
          return;
        }

        // Set button to loading state
        if (submitButton) {
          submitButton.dataset.state = "loading";
          submitButton.setAttribute("aria-disabled", true);
        }

        try {
          const result = await this.backInStockSubscription(
            emailInput.value,
            this.variantInput.value
          );
          
          if (!result.ok) {
            throw new Error("Failed to subscribe");
          }
          
          this.success(submitButton);
        } catch (error) {
          this.fail(error.message, submitButton);
        }
      }

      success(button) {
        if (button) {
          button.dataset.state = "success";
          button.removeAttribute("aria-disabled");
        }
        
        // Show success message
        const errorMessageWrapper = document.querySelector("error-message");
        if (errorMessageWrapper) {
          const errorMessageOutput = errorMessageWrapper.querySelector("span");
          errorMessageOutput.textContent = window.variantStrings?.waitlistSuccess || "You're now on the waitlist!";
          errorMessageWrapper.classList.remove("hidden");
          errorMessageWrapper.classList.add("!bg-success", "!text-white");
          setTimeout(() => {
            errorMessageWrapper.classList.add("hidden");
            errorMessageWrapper.classList.remove("!bg-success", "!text-white");
          }, 3000);
        }
        
        // Reset button state after delay
        setTimeout(() => {
          if (button) {
            button.removeAttribute("data-state");
          }
        }, 3000);
      }

      fail(message, button) {
        if (button) {
          button.dataset.state = "error";
          button.removeAttribute("aria-disabled");
          setTimeout(() => {
            button.removeAttribute("data-state");
          }, 3000);
        }
        
        // Show error message
        const errorMessageWrapper = document.querySelector("error-message");
        if (errorMessageWrapper) {
          const errorMessageOutput = errorMessageWrapper.querySelector("span");
          errorMessageOutput.textContent = `Failed to join waitlist: ${message}`;
          errorMessageWrapper.classList.remove("hidden");
          setTimeout(() => {
            errorMessageWrapper.classList.add("hidden");
          }, 3000);
        }
        
        console.error("Klaviyo waitlist error:", message);
      }

      async backInStockSubscription(email, variantId) {
        const raw = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        };

        const options = {
          method: "POST",
          headers: {
            accept: "application/json",
            revision: "2023-10-15",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(raw),
        };

        return fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=NnE5A3",
          options
        ).catch((err) => {
          console.error("Klaviyo API error:", err);
          throw err;
        });
      }
    },
    { extends: "form" }
  );
}

// Product Buttons Custom Element
// Observes the 'available' attribute and updates button text/styling accordingly
if (!customElements.get("product-buttons")) {
  customElements.define(
    "product-buttons",
    class ProductButtons extends HTMLElement {
      static get observedAttributes() {
        return ["availability", "available"];
      }

      constructor() {
        super();
        this.button = null;
        this.buttonTextElement = null;
        this.originalText = null;
        this.originalHTML = null;
      }

      connectedCallback() {
        this.button = this.querySelector('button[type="submit"]');
        if (!this.button) return;

        // Find the text element within the button
        // The button structure has a span with class "default-context" containing the text
        this.buttonTextElement = this.button.querySelector('.default-context');
        if (this.buttonTextElement) {
          // Always store original content immediately when connected
          // This ensures we have it before any state changes
          this.originalText = this.buttonTextElement.textContent.trim();
          this.originalHTML = this.buttonTextElement.innerHTML;
        }

        // Update initial state (also update when available attribute changes on connect)
        // Use a small delay to ensure attribute is set
        requestAnimationFrame(() => {
          this.updateButtonState();
        });
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name !== "availability" && name !== "available") return;

        // If button or textElement not found, try to find them again
        if (!this.button || !this.buttonTextElement) {
          this.button = this.querySelector('button[type="submit"]');
          if (this.button) {
            this.buttonTextElement = this.button.querySelector('.default-context');
            if (this.buttonTextElement && !this.originalHTML) {
              this.originalHTML = this.buttonTextElement.innerHTML;
              this.originalText = this.buttonTextElement.textContent.trim();
            }
          }
        }

        // Always update, even if values appear the same (they might be string vs boolean)
        this.updateButtonState();
      }

      setCtaLabel(html) {
        this.button = this.querySelector('button[type="submit"]');
        this.buttonTextElement = this.button?.querySelector(".default-context") || null;
        if (this.buttonTextElement && typeof html === "string") {
          this.buttonTextElement.innerHTML = html;
          this.originalHTML = html;
          this.originalText = this.buttonTextElement.textContent.trim();
        }
        this.updateButtonState();
      }

      updateButtonState() {
        if (!this.button) {
          this.button = this.querySelector('button[type="submit"]');
        }
        if (!this.buttonTextElement && this.button) {
          this.buttonTextElement = this.button.querySelector('.default-context');
        }
        if (!this.button) return;

        const availabilityState = this.#getAvailabilityState();
        const isAvailable = availabilityState === "available";
        const isStickyAtcButton = Boolean(this.closest("sticky-atc"));
        const unavailableText = window.variantStrings?.unavailable || "Unavailable";
        const soldOutText = window.variantStrings?.outOfStock || window.variantStrings?.soldOut || "Out of stock";
        const disabledText = availabilityState === "sold-out" ? soldOutText : unavailableText;

        if (this.buttonTextElement && !this.originalHTML && !isStickyAtcButton) {
          const currentText = this.buttonTextElement.textContent.trim();
          if (currentText !== unavailableText && currentText !== soldOutText) {
            this.originalHTML = this.buttonTextElement.innerHTML;
            this.originalText = currentText;
          }
        }

        // Always ensure originalHTML is stored when available
        // Store it if we're switching to available and don't have it yet
        if (isAvailable && this.buttonTextElement && !this.originalHTML && !isStickyAtcButton) {
          // Only store if current content is not "Unavailable" (meaning it's the actual original)
          const currentText = this.buttonTextElement.textContent.trim();
          if (currentText !== unavailableText && currentText !== soldOutText) {
            this.originalHTML = this.buttonTextElement.innerHTML;
            this.originalText = currentText;
          }
        }

        if (isAvailable) {
          // Available state - restore original text and styling
          if (this.buttonTextElement && this.originalHTML && !isStickyAtcButton) {
            // Restore original content
            this.buttonTextElement.innerHTML = this.originalHTML;
          } else if (this.buttonTextElement && this.originalText && !isStickyAtcButton) {
            // Fallback to text only if HTML not stored
            this.buttonTextElement.textContent = this.originalText;
          } else if (this.buttonTextElement && !isStickyAtcButton) {
            // Last resort: try to find the original text from the button's dataset or just use default
            const addToCartText = window.variantStrings?.addToCart || "Add to Cart";
            this.buttonTextElement.textContent = addToCartText;
            this.originalHTML = this.buttonTextElement.innerHTML;
            this.originalText = addToCartText;
          }
          // Restore original styling
          this.button.style.backgroundColor = "";
          this.button.style.opacity = "";
          this.button.style.cursor = "";
          this.button.style.color = "";
          this.button.removeAttribute("aria-disabled");
          this.button.removeAttribute("disabled");
        } else {
          // Disabled state - show the matching label and mute the button
          if (this.buttonTextElement && !isStickyAtcButton) {
            const currentText = this.buttonTextElement.textContent.trim();
            if (!this.originalHTML && currentText !== unavailableText && currentText !== soldOutText) {
              this.originalHTML = this.buttonTextElement.innerHTML;
              this.originalText = currentText;
            }

            // Preserve icon if present, update text only
            const icon = this.buttonTextElement.querySelector('svg');
            if (icon) {
              // Rebuild the content so the label never duplicates when toggling states.
              const iconClone = icon.cloneNode(true);
              const textWrapper = document.createElement('div');
              textWrapper.textContent = disabledText;
              this.buttonTextElement.replaceChildren(iconClone, textWrapper);
            } else {
              // No icon - just update text
              this.buttonTextElement.textContent = disabledText;
            }
          }
          
          // Apply disabled styling (grey, disabled appearance)
          this.button.style.backgroundColor = 'rgb(156 163 175)'; // gray-400
          this.button.style.opacity = '0.5';
          this.button.style.cursor = 'not-allowed';
          this.button.style.color = 'rgb(107 114 128)'; // gray-500
          this.button.setAttribute("aria-disabled", "true");
          this.button.setAttribute("disabled", "disabled");
        }
      }

      #getAvailabilityState() {
        const availabilityAttr = this.getAttribute("availability");
        if (availabilityAttr === "available" || availabilityAttr === "sold-out" || availabilityAttr === "unavailable") {
          return availabilityAttr;
        }

        const availableAttr = this.getAttribute("available");
        const isAvailable = availableAttr === "true" || availableAttr === "" || availableAttr === null;
        return isAvailable ? "available" : "unavailable";
      }
    }
  );
}
})();
(function () {
/**
 * Length Slider Component
 * 
 * Single-value range slider for selecting product length variants.
 * Controls hidden radio buttons to maintain compatibility with variant-radios component.
 * Filters available lengths based on currently selected variant combination.
 */

if (!customElements.get('length-slider')) {
  class LengthSlider extends HTMLElement {
    #abortController;
    #mutationObserver;
    #rangeInput;
    #radioInputs;
    #selectedOption;
    #markers;
    #isUpdating = false; // Flag to prevent recursive updates
    
    constructor() {
      super();
      this.#abortController = new AbortController();
    }
    
    connectedCallback() {
      const signal = { signal: this.#abortController.signal };
      
      // Cache DOM references
      this.#rangeInput = this.querySelector('input[type="range"].length-range-slider');
      this.#radioInputs = [...this.querySelectorAll('input[type="radio"].length-radio')];
      this.#selectedOption = this.querySelector('._selectedOption');
      this.#markers = [...this.querySelectorAll('.length-marker')];
      
      if (!this.#rangeInput || this.#radioInputs.length === 0) {
        console.warn('LengthSlider: Missing required elements');
        return;
      }

      const checkedIndex = this.#radioInputs.findIndex((radio) => radio.checked);
      if (checkedIndex >= 0) {
        this.#rangeInput.value = checkedIndex;
      }
      
      // Initialize visual state
      this.#updateVisualState();

      this.#mutationObserver = new MutationObserver(() => {
        const checkedIndex = this.#radioInputs.findIndex((radio) => radio.checked);
        if (checkedIndex >= 0 && parseInt(this.#rangeInput.value) !== checkedIndex) {
          this.#rangeInput.value = checkedIndex;
        }
        this.#updateVisualState();
      });

      this.#mutationObserver.observe(this, {
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'available', 'disabled']
      });
      
      // Range slider input handler - apply selection immediately for live price updates.
      this.#rangeInput.addEventListener('input', (e) => {
        const index = parseInt(e.target.value);
        if (index < 0 || index >= this.#radioInputs.length) {
          return;
        }

        this.#handleSliderChange(index, true);
      }, signal);
      
      // Change still fires on release; keep it visual-only to avoid duplicate variant cascades.
      this.#rangeInput.addEventListener('change', (e) => {
        const index = parseInt(e.target.value);
        if (index < 0 || index >= this.#radioInputs.length) {
          return;
        }
        this.#updateVisualState();
      }, signal);
      
      // Radio button change handler - sync slider when radio changes externally
      // Only update if the change came from outside (not from our slider)
      this.#radioInputs.forEach((radio, index) => {
        radio.addEventListener('change', (e) => {
          // Prevent recursive updates - if we're updating, ignore this event
          if (this.#isUpdating) return;
          
          // Only sync if the radio is checked and slider value doesn't match
          if (radio.checked && parseInt(this.#rangeInput.value) !== index) {
            this.#rangeInput.value = index;
            this.#updateVisualState();
          }
        }, signal);
      });

      this.addEventListener('click', (event) => {
        this.#handleMarkerClick(event);
      }, signal);

      this.addEventListener('keydown', (event) => {
        this.#handleMarkerKeydown(event);
      }, signal);
    }

    /**
     * Re-sync the slider UI from the current radio state.
     * Useful after parent variant availability changes where radio properties
     * are updated programmatically.
     */
    refreshFromRadios() {
      this.#radioInputs = [...this.querySelectorAll('input[type="radio"].length-radio')];
      this.#markers = [...this.querySelectorAll('.length-marker')];

      if (!this.#rangeInput || this.#radioInputs.length === 0) {
        return;
      }

      const selectableRadios = this.#radioInputs.filter((radio) => !radio.disabled);

      if (selectableRadios.length === 0) {
        this.#syncAtcAvailability();
        return;
      }

      const checkedIndex = this.#radioInputs.findIndex((radio) => radio.checked);
      if (checkedIndex >= 0) {
        this.#rangeInput.value = checkedIndex;
      }

      this.#updateVisualState();
    }
    
    
    /**
     * Handle slider value change
     * @param {number} index - Selected option index
     * @param {boolean} dispatchChange - Whether to dispatch change event
     * @private
     */
    #handleSliderChange(index, dispatchChange = false) {
      if (index < 0 || index >= this.#radioInputs.length) return;
      if (this.#isUpdating) return; // Prevent recursive calls
      
      const selectedRadio = this.#radioInputs[index];
      if (!selectedRadio) return;
      
      // Check if radio is already selected - if so, only update visual if needed
      if (selectedRadio.checked) {
        // If already checked and we're just updating visual, do that and return
        if (!dispatchChange) {
          this.#updateVisualState();
          return;
        }
        // If already checked but we need to dispatch, just dispatch without setting checked again
        if (dispatchChange) {
          this.#updateVisualState();
          requestAnimationFrame(() => {
            selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
          });
          return;
        }
      }
      
      // Radio is not checked, so we need to update it
      this.#isUpdating = true;
      
      // Uncheck all radios first to ensure clean state
      this.#radioInputs.forEach(radio => {
        if (radio.checked) {
          radio.checked = false;
        }
      });
      
      // Set the selected radio
      selectedRadio.checked = true;
      
      // Update visual state
      this.#updateVisualState();
      
      // Dispatch change event to trigger variant-radios update (only on final selection)
      if (dispatchChange) {
        // Use requestAnimationFrame to ensure DOM is updated before dispatching
        requestAnimationFrame(() => {
          selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
          this.#isUpdating = false;
        });
      } else {
        this.#isUpdating = false;
      }
    }
    
    /**
     * Update visual state of slider and markers
     * @private
     */
    #updateVisualState() {
      if (!this.#rangeInput) return;
      
      const maxIndex = this.#radioInputs.length - 1;
      const rawSelectedIndex = parseInt(this.#rangeInput.value);
      const selectedIndex = Number.isNaN(rawSelectedIndex)
        ? 0
        : Math.min(Math.max(rawSelectedIndex, 0), maxIndex);
      this.#rangeInput.value = selectedIndex;
      
      // Calculate progress percentage - account for markers being positioned at specific percentages
      // First marker at 0%, last at 100%, others evenly spaced
      let progress = 0;
      if (maxIndex === 0) {
        progress = 100;
      } else if (maxIndex > 0) {
        progress = (selectedIndex / maxIndex) * 100;
      }
      
      // Update slider track progress
      const track = this.querySelector('.length-slider-track');
      if (track) {
        track.style.setProperty('--length-progress', `${progress}%`);
      }
      
      // Update selected option text
      const selectedRadio = this.#radioInputs[selectedIndex];
      if (selectedRadio && this.#selectedOption) {
        this.#selectedOption.textContent = selectedRadio.value;
      }
      
      // Update markers visual state (skip the zero marker)
      const valueMarkers = this.#markers.filter(marker => 
        marker.dataset.markerIndex !== undefined && !marker.classList.contains('length-marker-zero')
      );
      
      valueMarkers.forEach((marker) => {
        const markerIndex = parseInt(marker.dataset.markerIndex);
        if (isNaN(markerIndex)) return;
        
        const dot = marker.querySelector('.length-marker-dot');
        const label = marker.querySelector('.length-marker-label');
        const badge = marker.querySelector('.length-marker-badge');
        const markerRadio = this.#radioInputs[markerIndex];
        
        const isSelected = markerIndex === selectedIndex;
        const isUnavailable = markerRadio?.disabled || markerRadio?.getAttribute('available') === 'false';
        
        if (dot) {
          dot.classList.toggle('bg-subtle', isSelected && !isUnavailable);
          dot.classList.toggle('bg-emphasis', !isSelected || isUnavailable);
          dot.classList.toggle('opacity-50', isUnavailable);
          if (isSelected) {
            dot.style.width = '0.5rem';
            dot.style.height = '0.5rem';
          } else {
            dot.style.width = '0.25rem';
            dot.style.height = '0.25rem';
          }
        }
        
        if (label) {
          label.classList.toggle('font-medium', isSelected && !isUnavailable);
          label.classList.toggle('text-primary', isSelected && !isUnavailable);
          label.classList.toggle('opacity-50', !isSelected || isUnavailable);
          if (isSelected && !isUnavailable) {
            label.classList.add('bg-blue-700', 'rounded-full', 'text-on-accent!', 'px-2', 'py-0.5');
          } else {
            label.classList.remove('bg-blue-700', 'rounded-full', 'text-on-accent!', 'px-2', 'py-0.5');
          }
        }
        
        // Show badge only on selected marker
        if (badge) {
          badge.style.display = isSelected ? 'block' : 'none';
        }
      });

      this.#syncAtcAvailability();
    }

    /**
     * Handle marker click interactions.
     * @param {MouseEvent} event - Click event from marker area.
     * @private
     */
    #handleMarkerClick(event) {
      const marker = event.target.closest('.length-marker[data-marker-index]');
      if (!marker || !this.contains(marker)) {
        return;
      }

      this.#activateMarker(marker, event);
    }

    /**
     * Handle keyboard activation for focused markers.
     * @param {KeyboardEvent} event - Keyboard event on marker.
     * @private
     */
    #handleMarkerKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      const marker = event.target.closest('.length-marker[data-marker-index]');
      if (!marker || !this.contains(marker)) {
        return;
      }

      this.#activateMarker(marker, event);
    }

    /**
     * Activate a length marker by selecting its matching radio.
     * This follows the same radio change path as the range input so sticky
     * dropdown and variant state stay in sync.
     * @param {HTMLElement} marker - Marker element to activate.
     * @param {Event} event - Source event to prevent default behavior.
     * @private
     */
    #activateMarker(marker, event) {
      const markerIndex = Number.parseInt(marker.dataset.markerIndex, 10);
      if (Number.isNaN(markerIndex) || markerIndex < 0 || markerIndex >= this.#radioInputs.length) {
        return;
      }

      const markerRadio = this.#radioInputs[markerIndex];
      if (!markerRadio || markerRadio.disabled) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (Number.parseInt(this.#rangeInput.value, 10) !== markerIndex) {
        this.#rangeInput.value = markerIndex;
      }

      this.#handleSliderChange(markerIndex, true);
    }

    /**
     * Ensure add-to-cart reflects the selected length radio availability.
     * This guards against stale button state when slider-driven changes finish
     * slightly before the parent variant component recomputes availability.
     * @private
     */
    #syncAtcAvailability() {
      const variantRadios = this.closest('variant-radios');
      if (!variantRadios || typeof variantRadios.updateButtonAvailability !== 'function') {
        return;
      }

      if (this.#radioInputs.filter((radio) => !radio.disabled).length === 0) {
        const productParent = this.closest('[data-section][data-product]');
        const productButtons = productParent?.querySelectorAll('product-buttons') || [];
        const quantityInput = productParent?.querySelector('quantity-input');

        productButtons.forEach((button) => {
          button.setAttribute('availability', 'unavailable');
          button.setAttribute('available', 'false');
          if (typeof button.updateButtonState === 'function') {
            button.updateButtonState();
          }
        });

        quantityInput?.setAttribute('available', 'false');
        return;
      }

      const selectedIndex = parseInt(this.#rangeInput?.value);
      const selectedRadio = Number.isNaN(selectedIndex)
        ? null
        : this.#radioInputs[selectedIndex];
      const isSelectedLengthUnavailable = !!selectedRadio
        && (selectedRadio.disabled || selectedRadio.getAttribute('available') === 'false');

      if (isSelectedLengthUnavailable) {
        const productParent = this.closest('[data-section][data-product]');
        const productButtons = productParent?.querySelectorAll('product-buttons') || [];
        const quantityInput = productParent?.querySelector('quantity-input');

        productButtons.forEach((button) => {
          button.setAttribute('availability', 'unavailable');
          button.setAttribute('available', 'false');
          if (typeof button.updateButtonState === 'function') {
            button.updateButtonState();
          }
        });

        quantityInput?.setAttribute('available', 'false');
        return;
      }

      variantRadios.updateButtonAvailability();
      requestAnimationFrame(() => {
        variantRadios.updateButtonAvailability();
      });
    }
    
    disconnectedCallback() {
      this.#abortController?.abort();
      this.#mutationObserver?.disconnect();
      // Clear references to prevent memory leaks
      this.#rangeInput = null;
      this.#radioInputs = [];
      this.#selectedOption = null;
      this.#markers = [];
    }
  }
  
  customElements.define('length-slider', LengthSlider);
  
  // Check for existing elements that might need upgrading when DOM is ready
  const checkAndUpgrade = () => {
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndUpgrade);
  } else {
    checkAndUpgrade();
  }
  
  // Also check after a delay to catch dynamically added elements
  setTimeout(checkAndUpgrade, 1000);
}
})();
(function () {
if (!customElements.get("variant-radios")) {
  /**
   * Parse amps (number before first dash) and kW (first number after first dash) for power labels.
   * @param {string} value - Raw option value, e.g. "32A - 22 kW", "32 - 22"
   * @returns {{ amps: number, kw: number }}
   */
  function parsePowerOptionValue(value) {
    if (!value || typeof value !== "string") {
      return { amps: 0, kw: 0 };
    }
    const trimmed = value.trim();
    const dashMatch = trimmed.match(/\s*-\s*/);
    let before = trimmed;
    let after = "";
    if (dashMatch && dashMatch.index !== undefined && dashMatch.index >= 0) {
      before = trimmed.slice(0, dashMatch.index);
      after = trimmed.slice(dashMatch.index + dashMatch[0].length);
    }
    const mA = before.match(/(\d+(?:[.,]\d+)?)/);
    const mB = after.match(/(\d+(?:[.,]\d+)?)/);
    const amps = mA ? parseFloat(mA[1].replace(",", ".")) : 0;
    const kw = mB ? parseFloat(mB[1].replace(",", ".")) : 0;
    return { amps, kw };
  }

  /**
   * Higher amps first; same amps → higher kW first.
   * @param {string} a
   * @param {string} b
   * @returns {number}
   */
  function comparePowerOptionValuesDescending(a, b) {
    const pa = parsePowerOptionValue(a);
    const pb = parsePowerOptionValue(b);
    if (pa.amps !== pb.amps) {
      return pb.amps - pa.amps;
    }
    return pb.kw - pa.kw;
  }

  /**
   * Normalize option labels for lookups.
   * Locale translations often include leading/trailing spaces or mixed case
   * (e.g. " Længde"); those must not break name matching.
   * @param {string} name
   * @returns {string}
   */
  function normalizeOptionName(name) {
    if (typeof name !== "string") {
      return "";
    }
    return name.trim().toLowerCase();
  }

  /**
   * Find an option name in a list with space/case-insensitive equality.
   * @param {Array<string>} optionNames
   * @param {string} fieldsetName
   * @returns {number} Index or -1
   */
  function findOptionNameIndex(optionNames, fieldsetName) {
    const needle = normalizeOptionName(fieldsetName);
    if (!needle || !Array.isArray(optionNames)) {
      return -1;
    }
    return optionNames.findIndex((name) => normalizeOptionName(name) === needle);
  }

  /** Length the shopper picked on the slider. Auto-remaps never write this. */
  const userPickedLengthBySection = new Map();

  class VariantRadios extends HTMLElement {
    constructor() {
      super();
      // Don't initialize anything in constructor - element might not be in DOM yet
      // All initialization happens in connectedCallback
    }

    connectedCallback() {
      // Initialize all properties when element is in DOM
      this.quickAtcMode = this.dataset.quickAtcMode;
      this.productParentElement = this.closest(`[data-section][data-product]`);

      if (this.productParentElement) {
        this.dataset.section = this.dataset.section || this.productParentElement.dataset.section;
        this.dataset.product = this.productParentElement.dataset.product;
      }

      // Get all fieldsets (including length-slider)
      this.fieldsets = [...this.querySelectorAll("fieldset")];

      this.#sortPowerOptionContainers();

      if (this.productParentElement) {
        this.qtyInput = this.productParentElement.querySelector("quantity-input");
        this.productButtons = this.productParentElement.querySelectorAll("product-buttons");
        this.productForms = this.productParentElement.querySelectorAll("product-form");
        this.outputs = this.productParentElement.querySelectorAll("._selectedOption");
      }

      this.stickyOutput = document.querySelector('._stickyOutput');
      this.stickyImageOutput = document.querySelector('._stickyImageOutput');

      if (this.productParentElement) {
        this.quantitySelector = this.productParentElement.querySelector("quantity-input");
      }

      // Combined listings support
      if (!this.optionUrls) {
        this.optionUrls = null;
      }
      if (!this.currentProductUrl) {
        this.currentProductUrl = null;
      }
      if (!this.currentTargetVariantId) {
        this.currentTargetVariantId = null;
      }
      if (!this.explicitTargetVariantId) {
        this.explicitTargetVariantId = null;
      }
      if (!this.explicitProductUrl) {
        this.explicitProductUrl = null;
      }
      if (!this.combinedListingsMap) {
        this.combinedListingsMap = null;
      }
      if (!this.selectionLinkIndex) {
        this.selectionLinkIndex = new Map();
      }
      if (!this.hasCombinedListings) {
        this.hasCombinedListings = false;
      }
      if (!this.productOptionNames) {
        this.productOptionNames = [];
      }
      if (!this.preferredLengthValue) {
        this.preferredLengthValue = "";
      }

      // Set up change event listener
      if (!this._changeHandler) {
        this._changeHandler = this.onVariantChange.bind(this);
      }
      this.addEventListener("change", this._changeHandler);
      if (!this._clickHandler) {
        this._clickHandler = this.onVariantClick.bind(this);
      }
      this.addEventListener("click", this._clickHandler);

      if (!document.getElementById('vr-no-flash')) {
        const s = document.createElement('style');
        s.id = 'vr-no-flash';
        s.textContent = 'variant-radios[data-computing],variant-radios[data-computing] *{transition:none!important}';
        document.head.append(s);
      }

      this.#loadOptionData();
      this.updateOptions();
      this.#syncLengthFromUrlVariant();
      this.updateVariantsAvailability();
      this.#syncLengthFromUrlVariant();
      this.#refreshLengthSliderState();
      this.updateVariantSelectedState(this.#hasCompleteSelection());

      const initialVariant = this.#getSelectedVariantFromOptions() || this.getCurrentVariant();
      if (initialVariant?.id) {
        this.#updateVariantInputWithId(initialVariant.id);
      }

      this.updateButtonAvailability();
      this.#syncGalleryToVariantOnReady();
    }

    handleFirstClick() {}

    /**
     * Reorder amps/kW option radios when values contain kW (data-option-sort="kw"): higher amps first, then higher kW (first dash).
     * @private
     */
    #sortPowerOptionContainers() {
      const containers = this.querySelectorAll("[data-option-sort=\"kw\"]");
      for (const container of containers) {
        const items = [...container.children].filter(
          (el) => el.querySelector && el.querySelector('input[type="radio"]'),
        );
        if (items.length < 2) {
          continue;
        }
        items.sort((a, b) => {
          const valA = a.querySelector('input[type="radio"]')?.value || "";
          const valB = b.querySelector('input[type="radio"]')?.value || "";
          return comparePowerOptionValuesDescending(valA, valB);
        });
        for (const el of items) {
          container.appendChild(el);
        }
      }
    }

    /**
     * Load combined listings map
     * @private
     */
    #loadOptionData() {
      this.variantFeaturedMediaMap = null;
      this.productOptionNames = [];

      const combinedListingsMap = this.#parseJsonScript(".combined-listings-map");
      if (Array.isArray(combinedListingsMap)) {
        this.combinedListingsMap = combinedListingsMap;
        this.hasCombinedListings = combinedListingsMap.length > 0;
      }

      const selectionLinkEntries = this.#parseJsonScript(".selection-link-map");
      if (selectionLinkEntries) {
        this.#loadSelectionLinkIndex(selectionLinkEntries);
      }

      const optionUrls = this.#parseJsonScript(".variant-option-urls-json");
      if (optionUrls) {
        this.optionUrls = optionUrls;
      }

      const featuredMediaMap = this.#parseJsonScript(".variant-featured-media-json");
      if (featuredMediaMap && typeof featuredMediaMap === "object") {
        this.variantFeaturedMediaMap = featuredMediaMap;
      }

      const parsedNames = this.#parseJsonScript(".product-option-names-json");
      if (Array.isArray(parsedNames)) {
        this.productOptionNames = parsedNames.filter((name) => typeof name === "string" && name.trim() !== "");
      }
    }

    /**
     * Parse a JSON script tag without aborting sibling maps on a single invalid payload.
     * @param {string} selector
     * @returns {*|null}
     * @private
     */
    #parseJsonScript(selector) {
      const element = this.querySelector(selector);
      if (!element?.textContent) {
        return null;
      }

      try {
        return JSON.parse(element.textContent);
      } catch (error) {
        console.error(`Failed to parse ${selector}:`, error);
        return null;
      }
    }

    /**
     * Load the exact selection-to-link index prepared in Liquid.
     * @param {Array<Object>} selectionLinkEntries - Server-rendered selection link entries
     * @private
     */
    #loadSelectionLinkIndex(selectionLinkEntries) {
      this.selectionLinkIndex = new Map();

      if (!Array.isArray(selectionLinkEntries)) {
        return;
      }

      for (const entry of selectionLinkEntries) {
        if (!entry || typeof entry.key !== "string" || !entry.url) {
          continue;
        }

        const candidates = this.selectionLinkIndex.get(entry.key) || [];
        candidates.push(entry);
        this.selectionLinkIndex.set(entry.key, candidates);
      }
    }

    onVariantChange(e) {
      // Only respond to radio button changes
      if (!e.target || e.target.type !== 'radio') {
        return;
      }

      const changedFieldset = e.target.closest('fieldset');
      const changedFieldsetIndex = this.fieldsets.findIndex((fieldset) => fieldset === changedFieldset);
      this.#setExplicitProductUrl(changedFieldsetIndex, e.target);
      this.#syncSelectionState(changedFieldsetIndex, { userIntent: true });
    }

    onVariantClick(e) {
      if (!e.target || e.target.type !== 'radio') {
        return;
      }

      const clickedFieldset = e.target.closest('fieldset');
      const clickedFieldsetIndex = this.fieldsets.findIndex((fieldset) => fieldset === clickedFieldset);
      if (clickedFieldsetIndex < 0) {
        return;
      }

      const currentOptions = Array.isArray(this.options) ? this.options : [];
      if (currentOptions[clickedFieldsetIndex] !== e.target.value) {
        return;
      }

      // Re-clicking the already-selected option should also re-run the cascade so
      // downstream options snap back to the first valid available choices.
      this.#setExplicitProductUrl(clickedFieldsetIndex, e.target);
      this.#syncSelectionState(clickedFieldsetIndex, { userIntent: true });
    }

    /**
     * Persist the explicitly chosen product URL for the last clicked option.
     * @param {number} fieldsetIndex - Fieldset index for the changed radio
     * @param {HTMLInputElement} radio - Selected radio
     * @private
     */
    #setExplicitProductUrl(fieldsetIndex, radio) {
      if (!radio || fieldsetIndex < 0) {
        return;
      }

      const fieldset = this.fieldsets[fieldsetIndex];
      const optionUrl = this.#getOptionUrlForRadio(fieldset, fieldsetIndex, radio);
      const targetVariantId = this.#getOptionTargetVariantIdForRadio(fieldset, fieldsetIndex, radio);
      this.explicitProductUrl = optionUrl || null;
      this.explicitTargetVariantId = targetVariantId || null;
    }

    /**
     * Clear checked radios after the changed fieldset so downstream options can be rebuilt.
     * @param {number} changedFieldsetIndex - Index of the fieldset that initiated the change
     * @private
     */
    #resetSelectionsAfter(changedFieldsetIndex) {
      if (typeof changedFieldsetIndex !== "number" || changedFieldsetIndex < 0) {
        return;
      }

      const lengthOptionIndex = this.#getLengthOptionIndex();

      this.fieldsets.forEach((fieldset, fieldsetIndex) => {
        if (fieldsetIndex <= changedFieldsetIndex) {
          return;
        }
        if (fieldsetIndex === lengthOptionIndex || fieldset.closest("length-slider")) {
          return;
        }

        [...fieldset.elements].forEach((radio) => {
          if (radio.type === "radio" && radio.checked) {
            radio.checked = false;
          }
        });
      });
    }

    /**
     * Reset downstream groups when switching product family (Type), so a leftover
     * value like OCPP's 16A-11kW is not kept on Schuko/CEE.
     * @param {number} changedFieldsetIndex
     * @param {HTMLInputElement|null} radio
     * @returns {boolean}
     * @private
     */
    #shouldResetDownstream(changedFieldsetIndex, radio) {
      if (changedFieldsetIndex === 0) {
        return true;
      }

      if (!radio || changedFieldsetIndex < 0) {
        return false;
      }

      const optionUrl = this.#getOptionUrlForRadio(
        this.fieldsets[changedFieldsetIndex],
        changedFieldsetIndex,
        radio
      );
      if (!optionUrl) {
        return false;
      }

      const changedUrl = this.#normalizeProductUrl(optionUrl);
      const currentUrl = this.#normalizeProductUrl(this.dataset.url);
      return changedUrl !== "" && currentUrl !== "" && changedUrl !== currentUrl;
    }

    /**
     * Stable key for section-scoped length memory.
     * @returns {string}
     * @private
     */
    #preferredLengthStorageKey() {
      return this.dataset.section || this.productParentElement?.dataset.section || "pdp";
    }

    /**
     * Persist a slider length the shopper chose themselves.
     * @param {string} value
     * @private
     */
    #persistUserPickedLength(value) {
      const lengthValue = typeof value === "string" ? value.trim() : "";
      if (!lengthValue) {
        return;
      }

      this.preferredLengthValue = lengthValue;
      userPickedLengthBySection.set(this.#preferredLengthStorageKey(), lengthValue);
      if (this.productParentElement) {
        this.productParentElement.dataset.preferredLength = lengthValue;
      }
    }

    /**
     * Length the shopper last set on the slider. Empty until they touch it.
     * @returns {string}
     * @private
     */
    #getUserPickedLength() {
      return userPickedLengthBySection.get(this.#preferredLengthStorageKey())
        || this.preferredLengthValue
        || "";
    }

    /**
     * @param {string} [_rawUrl]
     * @returns {string}
     * @private
     */
    #getLengthForUrl(_rawUrl) {
      return this.#getUserPickedLength();
    }

    /**
     * Variant from the URL `variant` param, then Liquid current-variant JSON.
     * @returns {Object|null}
     * @private
     */
    #getVariantFromUrlOrJson() {
      try {
        const variantId = new URLSearchParams(window.location.search).get("variant");
        if (variantId) {
          const fromUrl = this.#findVariantById(variantId, this.#getAllVariants());
          if (fromUrl) {
            return fromUrl;
          }
        }
      } catch (error) {}

      return this.getCurrentVariant();
    }

    /**
     * Check the length radio that matches the URL/Liquid variant so reload
     * does not snap the slider back to the first length.
     * @private
     */
    #syncLengthFromUrlVariant() {
      const variant = this.#getVariantFromUrlOrJson();
      const lengthOptionIndex = this.#getLengthOptionIndex();
      if (!variant || lengthOptionIndex < 0 || !this.fieldsets[lengthOptionIndex]) {
        return;
      }

      const resolved = this.#resolveSourceOptionIndex(variant, lengthOptionIndex);
      const lengthValue = resolved.exists
        ? variant.options[resolved.index]
        : (Array.isArray(variant.options) ? variant.options[variant.options.length - 1] : "");
      if (typeof lengthValue !== "string" || lengthValue.trim() === "") {
        return;
      }

      const radios = [...this.fieldsets[lengthOptionIndex].elements].filter(
        (radio) => radio.type === "radio"
      );
      const match = radios.find((radio) => radio.value === lengthValue);
      if (!match) {
        return;
      }

      radios.forEach((radio) => {
        radio.checked = radio === match;
      });
      this.updateOptions();
    }

    /**
     * Store length only when the user actually changed it, keyed by the current product.
     * Auto-remaps (6m → Carbon 5m/10m) must not overwrite Standard's 6m.
     * @param {number} [changedFieldsetIndex=-1]
     * @param {{userIntent?: boolean}} [options]
     * @private
     */
    #rememberLengthSelection(changedFieldsetIndex = -1, { userIntent = false } = {}) {
      const lengthOptionIndex = this.#getLengthOptionIndex();
      if (lengthOptionIndex < 0 || !this.fieldsets[lengthOptionIndex]) {
        return;
      }

      if (!userIntent || changedFieldsetIndex !== lengthOptionIndex) {
        return;
      }

      const checked = [...this.fieldsets[lengthOptionIndex].elements].find(
        (radio) => radio.type === "radio" && radio.checked
      );
      if (checked?.value) {
        this.#persistUserPickedLength(checked.value);
      }
    }

    /**
     * Re-select the remembered length when that value still exists on the current product.
     * @returns {boolean} True when the checked length radio changed
     * @private
     */
    #applyLengthPolicySelection() {
      const lengthOptionIndex = this.#getLengthOptionIndex();
      if (lengthOptionIndex < 0 || !this.fieldsets[lengthOptionIndex]) {
        return false;
      }

      const radios = [...this.fieldsets[lengthOptionIndex].elements].filter(
        (radio) => radio.type === "radio"
      );
      const userLength = this.#getUserPickedLength();
      const match = userLength
        ? radios.find((radio) => (
          radio.value === userLength
          && !radio.disabled
          && radio.getAttribute("available") !== "false"
        )) || this.#pickClosestAvailableLengthRadio(radios, userLength)
        : this.#pickSmallestAvailableLengthRadio(radios);

      if (!match || match.disabled || match.getAttribute("available") === "false") {
        return false;
      }

      const current = radios.find((radio) => radio.checked) || null;
      if (current === match) {
        return false;
      }

      if (current) {
        current.checked = false;
      }
      match.checked = true;
      return true;
    }

    /**
     * Variant ID that preserves the remembered length when switching product family.
     * Falls back to the closest available length on the target product (6m → Carbon 5m).
     * @returns {string|null}
     * @private
     */
    #getPreferredVariantIdForFetch() {
      const lengthOptionIndex = this.#getLengthOptionIndex();
      const targetUrl = this.explicitProductUrl || this.currentProductUrl || this.dataset.url || "";
      const userLength = this.#getUserPickedLength();

      if (lengthOptionIndex >= 0 && Array.isArray(this.options)) {
        const policyId = userLength
          ? this.#getClosestLengthVariantId(userLength, targetUrl)
          : this.#getSmallestLengthVariantId(targetUrl);
        if (policyId) {
          return policyId;
        }
      }

      const exactMatch = this.#getExactCombinedListingMatch(this.options);
      if (exactMatch?.variantId) {
        return String(exactMatch.variantId);
      }

      const candidates = this.#getSelectionCandidates(this.options);
      if (!Array.isArray(candidates) || candidates.length === 0) {
        return this.currentTargetVariantId ? String(this.currentTargetVariantId) : null;
      }

      const preferredUrl = this.#normalizeProductUrl(targetUrl);
      const available = candidates.filter((entry) => entry.available === true);
      const pick = available.find((entry) => this.#normalizeProductUrl(entry.url) === preferredUrl)
        || available[0]
        || candidates.find((entry) => this.#normalizeProductUrl(entry.url) === preferredUrl)
        || candidates[0];

      return pick?.variantId ? String(pick.variantId) : (this.currentTargetVariantId ? String(this.currentTargetVariantId) : null);
    }

    /**
     * Closest available length variant on the target product.
     * Exact match wins (delta 0), otherwise nearest meters (2m → Carbon 5m).
     * @param {string} preferredLength - Remembered length label, e.g. "2 Meter"
     * @param {string} [targetUrl=""] - Normalized product URL to pin the lookup
     * @returns {string|null}
     * @private
     */
    #getClosestLengthVariantId(preferredLength, targetUrl = "") {
      const lengthOptionIndex = this.#getLengthOptionIndex();
      if (lengthOptionIndex < 0 || !Array.isArray(this.options)) {
        return null;
      }

      const preferredMeters = this.#extractMetersFromLengthValue(preferredLength);
      if (preferredMeters <= 0) {
        return null;
      }

      const nonLengthOptions = this.options.map((option, index) => (
        index === lengthOptionIndex ? null : option
      ));
      const candidates = this.#getMatchingCombinedListings(nonLengthOptions);
      if (!Array.isArray(candidates) || candidates.length === 0) {
        return null;
      }

      const preferredUrl = this.#normalizeProductUrl(
        targetUrl || this.explicitProductUrl || this.currentProductUrl || this.dataset.url || ""
      );
      const urlPool = preferredUrl
        ? candidates.filter((entry) => this.#normalizeProductUrl(entry.url) === preferredUrl)
        : [];
      const pool = urlPool.length > 0 ? urlPool : candidates;
      const available = pool.filter((entry) => entry.available === true);
      const searchPool = available.length > 0 ? available : pool;

      let best = null;
      let bestDelta = Infinity;

      searchPool.forEach((entry) => {
        const resolved = this.#resolveSourceOptionIndex(entry, lengthOptionIndex);
        if (!resolved.exists) {
          return;
        }

        const optionValues = this.#getSourceOptionValues(entry);
        const lengthLabel = optionValues[resolved.index];
        if (lengthLabel === preferredLength) {
          best = entry;
          bestDelta = 0;
          return;
        }

        const meters = this.#extractMetersFromLengthValue(lengthLabel);
        if (meters <= 0) {
          return;
        }

        const delta = Math.abs(meters - preferredMeters);
        if (delta < bestDelta) {
          bestDelta = delta;
          best = entry;
        }
      });

      return best?.variantId ? String(best.variantId) : null;
    }

    /**
     * Shortest available length variant on the target product.
     * @param {string} [targetUrl=""]
     * @returns {string|null}
     * @private
     */
    #getSmallestLengthVariantId(targetUrl = "") {
      const lengthOptionIndex = this.#getLengthOptionIndex();
      if (lengthOptionIndex < 0 || !Array.isArray(this.options)) {
        return null;
      }

      const nonLengthOptions = this.options.map((option, index) => (
        index === lengthOptionIndex ? null : option
      ));
      const candidates = this.#getMatchingCombinedListings(nonLengthOptions);
      if (!Array.isArray(candidates) || candidates.length === 0) {
        return null;
      }

      const preferredUrl = this.#normalizeProductUrl(
        targetUrl || this.explicitProductUrl || this.currentProductUrl || this.dataset.url || ""
      );
      const urlPool = preferredUrl
        ? candidates.filter((entry) => this.#normalizeProductUrl(entry.url) === preferredUrl)
        : [];
      const pool = urlPool.length > 0 ? urlPool : candidates;
      const available = pool.filter((entry) => entry.available === true);
      const searchPool = available.length > 0 ? available : pool;

      let best = null;
      let bestMeters = Infinity;

      searchPool.forEach((entry) => {
        const resolved = this.#resolveSourceOptionIndex(entry, lengthOptionIndex);
        if (!resolved.exists) {
          return;
        }

        const optionValues = this.#getSourceOptionValues(entry);
        const meters = this.#extractMetersFromLengthValue(optionValues[resolved.index]);
        if (meters <= 0 || meters >= bestMeters) {
          return;
        }

        bestMeters = meters;
        best = entry;
      });

      return best?.variantId ? String(best.variantId) : null;
    }

    /**
     * Variant that matches the remembered length on the target product.
     * Does not fall back to leftover closest radios — those belong to the previous family.
     * @returns {Object|null}
     * @private
     */
    #getResolvedPreferredVariant() {
      const preferredVariantId = this.#getPreferredVariantIdForFetch();
      if (preferredVariantId) {
        this.currentTargetVariantId = preferredVariantId;
      }

      return this.#findVariantById(preferredVariantId, this.#getAllVariants());
    }

    /**
     * Write price, form id, and sticky UI from a resolved variant.
     * @param {Object|null} selectedVariant
     * @returns {boolean}
     * @private
     */
    #applyResolvedVariantToUi(selectedVariant) {
      if (!selectedVariant?.id) {
        return false;
      }

      this.currentTargetVariantId = String(selectedVariant.id);
      this.#updateVariantInputWithId(selectedVariant.id);
      this.#syncCurrentVariantJson(selectedVariant);
      this.#updateLocalLengthPrice(selectedVariant);
      this.updateStickyOutput();
      return true;
    }

    /**
     * Restore the remembered length radio, then always rewrite price for that variant.
     * Section HTML often still has the closest leftover length's price.
     * @private
     */
    #restorePreferredLengthAndPrice() {
      if (this.#applyLengthPolicySelection()) {
        this.updateOptions();
        this.updateVariantsAvailability();
      }
      this.updateOptions();
      const selectedVariant = this.#getResolvedPreferredVariant()
        || this.#getSelectedVariantFromOptions();
      this.#applyResolvedVariantToUi(selectedVariant);
      this.#refreshLengthSliderState();
      this.updateOutputs();
      this.updateVariantSelectedState(this.#hasCompleteSelection());
      this.updateButtonAvailability();
      this.updateURL();
    }

    /**
     * Recompute selection, availability, URL, and product state after a variant choice.
     * @param {number} changedFieldsetIndex - Index of the fieldset that initiated the change
     * @private
     */
    #syncSelectionState(changedFieldsetIndex, { userIntent = false } = {}) {
      this.dataset.computing = '';
      this.#rememberLengthSelection(changedFieldsetIndex, { userIntent });
      const changedFieldset = this.fieldsets[changedFieldsetIndex];
      const changedRadio = changedFieldset
        ? [...changedFieldset.elements].find((radio) => radio.type === "radio" && radio.checked)
        : null;
      if (this.#shouldResetDownstream(changedFieldsetIndex, changedRadio)) {
        this.#resetSelectionsAfter(changedFieldsetIndex);
      }
      this.updateOptions();
      this.updateVariantsAvailability(changedFieldsetIndex);
      if (this.#applyLengthPolicySelection()) {
        this.updateOptions();
        this.updateVariantsAvailability(changedFieldsetIndex);
      }
      this.#resolveDeadlockedFieldsets(changedFieldsetIndex);
      void this.offsetHeight;
      delete this.dataset.computing;
      this.#refreshLengthSliderState();
      this.updateVariantSelectedState(this.#hasCompleteSelection());
      this.updateOutputs();

      // Update which product URL we're using (for combined listings).
      this.updateCurrentProductUrl();
      if (this.explicitProductUrl) {
        const explicitUrl = this.#normalizeProductUrl(this.explicitProductUrl);
        const resolvedUrl = this.#normalizeProductUrl(this.currentProductUrl || this.dataset.url);
        if (explicitUrl && explicitUrl !== resolvedUrl) {
          this.currentProductUrl = this.explicitProductUrl;
        }
      }

      const selectedVariant = this.#getResolvedPreferredVariant()
        || this.#getSelectedVariantFromOptions();
      this.updateButtonAvailability();
      const hasLocalVariant = !!selectedVariant?.id;
      if (hasLocalVariant) {
        this.#applyResolvedVariantToUi(selectedVariant);
      }

      // Always update the URL to reflect the current product context, even when the
      // variant can't be resolved locally (cross-product navigation).
      this.updateURL();

      const shouldSkipFetchForLengthChange = this.#shouldSkipFetchForLengthChange(changedFieldsetIndex);
      if (hasLocalVariant && shouldSkipFetchForLengthChange) {
        this.#applyResolvedVariantToUi(selectedVariant);
        this.#syncGalleryToVariant(selectedVariant);
        this.#broadcastVariantChanged(selectedVariant);
        return;
      }

      this.renderProductInfo(hasLocalVariant);
      this.#broadcastVariantChanged(selectedVariant);
    }

    /**
     * Wait until the main gallery slider is ready, then sync to the selected variant.
     * Used on first paint when URL already has a variant selected.
     * @param {number} [attempt=0]
     * @private
     */
    #syncGalleryToVariantOnReady(attempt = 0) {
      const selectedVariant = this.#getSelectedVariantFromOptions() || this.getCurrentVariant();
      const sliderEl = this.productParentElement?.querySelector(
        'electric-slider[data-variant-dynamic="product-slider-main"]'
      );

      if (!selectedVariant || !sliderEl || typeof sliderEl.navigateSlider !== "function") {
        if (attempt < 40) {
          setTimeout(() => this.#syncGalleryToVariantOnReady(attempt + 1), 50);
        }
        return;
      }

      const hasItems = Array.isArray(sliderEl.items)
        ? sliderEl.items.length > 0
        : (sliderEl.items?.length || 0) > 0;

      if (!hasItems) {
        if (attempt < 40) {
          setTimeout(() => this.#syncGalleryToVariantOnReady(attempt + 1), 50);
        }
        return;
      }

      this.#syncGalleryToVariant(selectedVariant);
    }

    /**
     * Scroll the PDP gallery to the selected variant's featured media without
     * rebuilding the slider (used on length-only updates / initial ready sync).
     * @param {Object|null} selectedVariant
     * @private
     */
    #syncGalleryToVariant(selectedVariant) {
      if (!selectedVariant || !this.productParentElement) return;

      const mappedMediaId = this.#getFeaturedMediaIdForVariant(selectedVariant.id);
      const mediaId = mappedMediaId
        ?? selectedVariant.featured_media?.id
        ?? selectedVariant.featured_image?.id
        ?? null;
      const imageId = selectedVariant.featured_image?.id ?? null;
      const imageSrc = typeof selectedVariant.featured_image?.src === "string"
        ? selectedVariant.featured_image.src
        : "";

      if (mediaId == null && imageId == null && !imageSrc) return;

      const sliderEl = this.productParentElement.querySelector(
        'electric-slider[data-variant-dynamic="product-slider-main"]'
      );
      if (!sliderEl || typeof sliderEl.navigateSlider !== "function") return;

      // Match electric-slider's slide query so indices stay aligned with navigateSlider.
      const feed = sliderEl.querySelector(".electric-slider__feed");
      const excl = ":not(.electric-slider__thumbnails):not([data-electric-slider-ignore])";
      let slides = [];
      if (feed) {
        slides = feed.querySelector(":scope > *.contents")
          ? [...feed.querySelectorAll(`.contents > *${excl}`)]
          : [...feed.querySelectorAll(`:scope > *${excl}`)];
      }
      if (!slides.length) {
        slides = [...(sliderEl.items || [])];
      }
      if (!slides.length) return;

      // Keep the slider's item cache in sync for subsequent navigations.
      sliderEl.items = slides;

      const mediaIdStr = mediaId != null ? String(mediaId) : "";
      const imageIdStr = imageId != null ? String(imageId) : "";
      const normalizeImagePath = (value) => {
        if (typeof value !== "string" || !value) return "";
        return value
          .replace(/^https?:/, "")
          .replace(/^\/\//, "")
          .split("?")[0]
          // Shopify width suffixes: image_1200x.jpg / image_300x300.jpg
          .replace(/_\d+x(\d+)?(?=\.[a-zA-Z]+$)/, "");
      };
      const normalizedSrc = normalizeImagePath(imageSrc);

      const targetIndex = slides.findIndex((slide) => {
        if (!(slide instanceof HTMLElement)) return false;

        const slideMediaId = slide.dataset.productMediaId || "";
        const slideImageId = slide.dataset.productImageId || "";
        if (mediaIdStr && (slideMediaId === mediaIdStr || slideImageId === mediaIdStr)) {
          return true;
        }
        if (imageIdStr && (slideImageId === imageIdStr || slideMediaId === imageIdStr)) {
          return true;
        }

        if (!normalizedSrc) return false;
        const img = slide.matches?.("img") ? slide : slide.querySelector?.("img");
        const slideSrc = normalizeImagePath(
          img?.currentSrc || img?.src || img?.getAttribute?.("src") || ""
        );
        if (!slideSrc) return false;
        return slideSrc === normalizedSrc
          || slideSrc.endsWith(normalizedSrc)
          || normalizedSrc.endsWith(slideSrc);
      });

      if (targetIndex < 0) return;

      // Instant avoids stuck state when the previous smooth scroll hasn't finished
      // (center-align + suppressScrollIndexSync blocked subsequent navigations).
      sliderEl.navigateSlider(targetIndex, "instant");
    }

    /**
     * Look up featured media id from the Liquid-authored map (more reliable than variant JSON).
     * @param {string|number|null|undefined} variantId
     * @returns {string|number|null}
     * @private
     */
    #getFeaturedMediaIdForVariant(variantId) {
      if (variantId == null) return null;

      if (this.variantFeaturedMediaMap == null) {
        try {
          const mapEl = this.querySelector(".variant-featured-media-json");
          this.variantFeaturedMediaMap = mapEl?.textContent
            ? JSON.parse(mapEl.textContent)
            : {};
        } catch (error) {
          this.variantFeaturedMediaMap = {};
        }
      }

      if (!this.variantFeaturedMediaMap || typeof this.variantFeaturedMediaMap !== "object") {
        return null;
      }

      const mapped = this.variantFeaturedMediaMap[String(variantId)]
        ?? this.variantFeaturedMediaMap[variantId];
      return mapped == null ? null : mapped;
    }

    /**
     * Notify other sections (e.g. <variant-dynamic-section>) that the selection changed
     * so they can re-fetch and swap their own data-variant-dynamic content.
     * @param {Object|null} selectedVariant - Resolved variant from options (may be null mid-selection)
     * @private
     */
    #broadcastVariantChanged(selectedVariant) {
      try {
        const productUrl = this.currentProductUrl || this.dataset.url || "";
        const optionValueIds = [];
        this.fieldsets.forEach((fieldset) => {
          if (fieldset.hidden) return;
          const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
          if (checkedRadio?.dataset.optionValueId) {
            optionValueIds.push(checkedRadio.dataset.optionValueId);
          }
        });

        const variantId = selectedVariant?.id
          || this.currentTargetVariantId
          || this.explicitTargetVariantId
          || null;

        document.dispatchEvent(new CustomEvent('voldt:variant:changed', {
          detail: {
            productUrl,
            productId: this.#resolveBroadcastProductId(productUrl, variantId),
            variantId,
            optionValueIds,
            sourceSectionId: this.dataset.section || null,
          },
        }));
      } catch (error) {}
    }

    /**
     * Resolve the product id for variant-change listeners (upsells, reviews).
     * Prefers combined-listings map entries, then the current product parent dataset.
     * @param {string} productUrl
     * @param {string|number|null} variantId
     * @returns {string|null}
     * @private
     */
    #resolveBroadcastProductId(productUrl, variantId) {
      try {
        if (Array.isArray(this.combinedListingsMap) && this.combinedListingsMap.length) {
          if (variantId != null) {
            const byVariant = this.combinedListingsMap.find(
              (entry) => String(entry?.variantId) === String(variantId) && entry?.productId != null
            );
            if (byVariant?.productId != null) return String(byVariant.productId);
          }

          const normalizedUrl = this.#normalizeProductUrl(productUrl);
          if (normalizedUrl) {
            const byUrl = this.combinedListingsMap.find(
              (entry) => this.#normalizeProductUrl(entry?.url) === normalizedUrl && entry?.productId != null
            );
            if (byUrl?.productId != null) return String(byUrl.productId);
          }
        }

        const parentId = this.productParentElement?.dataset?.product;
        return parentId != null && parentId !== "" ? String(parentId) : null;
      } catch (error) {
        return null;
      }
    }

    /**
     * After the forward cascade, check if any non-length fieldset has zero available
     * options. If so, switch the first adjustable upstream fieldset to an alternative
     * value and re-run availability — a "reverse cascade."
     * @param {number} changedFieldsetIndex - Index the user changed (never adjusted)
     * @private
     */
    #resolveDeadlockedFieldsets(changedFieldsetIndex) {
      const lengthOptionIndex = this.#getLengthOptionIndex();

      const isDeadlocked = (fieldset, idx) => {
        if (idx === lengthOptionIndex) return false;
        const radios = [...fieldset.elements].filter((r) => r.type === 'radio');
        return radios.length > 0
          && !radios.some((r) => !r.disabled && r.getAttribute('available') === 'true');
      };

      if (!this.fieldsets.some(isDeadlocked)) return;

      for (let i = 0; i < this.fieldsets.length; i++) {
        if (i === changedFieldsetIndex || i === lengthOptionIndex) continue;

        const radios = [...this.fieldsets[i].elements].filter((r) => r.type === 'radio');
        const currentChecked = radios.find((r) => r.checked);

        const alternative = radios.find(
          (r) => r !== currentChecked && !r.disabled && r.getAttribute('available') === 'true'
        ) || radios.find((r) => r !== currentChecked && !r.disabled);

        if (!alternative) continue;

        if (currentChecked) currentChecked.checked = false;
        alternative.checked = true;
        this.updateOptions();
        this.updateVariantsAvailability(-1);

        if (!this.fieldsets.some(isDeadlocked)) return;
      }
    }

    updateVariantSelectedState(boolean) {
      this.productParentElement.dataset.variantSelected = boolean;
    }

    updateOutputs() {
      this.outputs.forEach((output) => {
        const index = parseInt(output.dataset.index);
        if (!isNaN(index) && this.options && this.options[index]) {
          output.innerHTML = this.options[index];
        }
      });
    }

    /**
     * Determine whether a section fetch can be skipped for the current change.
     * Length-only changes on the same product can update price from local variant JSON.
     * @param {number} changedFieldsetIndex - Index of the changed option fieldset
     * @returns {boolean} True when local update is safe
     * @private
     */
    #shouldSkipFetchForLengthChange(changedFieldsetIndex) {
      const lengthOptionIndex = this.#getLengthOptionIndex();
      if (lengthOptionIndex < 0 || changedFieldsetIndex !== lengthOptionIndex) {
        return false;
      }

      const baseUrl = this.currentProductUrl || this.dataset.url;
      const normalizedBaseUrl = this.#normalizeProductUrl(baseUrl);
      const normalizedDatasetUrl = this.#normalizeProductUrl(this.dataset.url);
      const isCrossProductNavigation = normalizedBaseUrl !== "" && normalizedBaseUrl !== normalizedDatasetUrl;
      return !isCrossProductNavigation;
    }

    /**
     * Keep current-variant-json aligned with selected local variant.
     * @param {Object} selectedVariant - Currently selected variant
     * @private
     */
    #syncCurrentVariantJson(selectedVariant) {
      if (!selectedVariant) {
        return;
      }

      const variantJsonElement = this.querySelector(".current-variant-json");
      if (!variantJsonElement) {
        return;
      }

      try {
        variantJsonElement.textContent = JSON.stringify(selectedVariant);
      } catch (error) {}
    }

    /**
     * Update product form price UI instantly for length-only changes.
     * @param {Object} selectedVariant - Currently selected variant
     * @private
     */
    #updateLocalLengthPrice(selectedVariant) {
      if (!selectedVariant || !this.productParentElement) {
        return;
      }

      const formattedPrice = this.#formatMoney(selectedVariant.price);
      const compareAtMarkup = this.#buildCompareAtPriceMarkup(selectedVariant);
      const chipMarkup = this.#buildLengthPriceChipMarkup(selectedVariant);
      const priceRowMarkup = `<div class="flex items-center justify-center gap-[1.2rem]"><span class="text-2xl font-medium leading-120">${formattedPrice}</span>${compareAtMarkup}</div>`;

      this.productParentElement.querySelectorAll(
        'product-form [data-variant-dynamic="variant-price"]'
      ).forEach((target) => {
        target.innerHTML = `${priceRowMarkup}${chipMarkup}`;
      });

      this.productParentElement.querySelectorAll(
        '[data-variant-dynamic="variant-price-sticky"]'
      ).forEach((target) => {
        target.textContent = formattedPrice;
      });
    }

    /**
     * Build compare-at price HTML when it is higher than the selling price.
     * Mirrors product--form.liquid output for rapid local updates.
     * @param {Object} selectedVariant - Currently selected variant
     * @returns {string} Compare-at HTML or empty string
     * @private
     */
    #buildCompareAtPriceMarkup(selectedVariant) {
      const price = Number(selectedVariant?.price);
      const compareAtPrice = Number(selectedVariant?.compare_at_price);

      if (!Number.isFinite(price) || !Number.isFinite(compareAtPrice) || compareAtPrice <= price) {
        return "";
      }

      return `<s class="text-body font-normal line-through opacity-30">${this.#formatMoney(compareAtPrice)}</s>`;
    }

    /**
     * Build the "/m + saved%" chip HTML for the selected length.
     * Mirrors product--form.liquid output for rapid local updates.
     * @param {Object} selectedVariant - Currently selected variant
     * @returns {string} Chip HTML or empty string
     * @private
     */
    #buildLengthPriceChipMarkup(selectedVariant) {
      const lengthOptionIndex = this.#getLengthOptionIndex();
      if (lengthOptionIndex < 0) {
        return "";
      }

      const selectedMeters = this.#extractMetersFromVariantOption(selectedVariant, lengthOptionIndex);
      if (selectedMeters <= 0) {
        return "";
      }

      const allVariants = this.#getAllVariants();
      const firstVariant = Array.isArray(allVariants) ? allVariants[0] : null;
      const firstVariantMeters = this.#extractMetersFromVariantOption(firstVariant, lengthOptionIndex);

      const pricePerMeter = Math.round(Number(selectedVariant.price || 0) / selectedMeters);
      const firstVariantPricePerMeter = firstVariantMeters > 0
        ? Math.round(Number(firstVariant?.price || 0) / firstVariantMeters)
        : 0;

      let savingsPercentage = 0;
      if (firstVariantPricePerMeter > 0) {
        savingsPercentage = Math.round(
          ((firstVariantPricePerMeter - pricePerMeter) * 100) / firstVariantPricePerMeter
        );
      }

      const priceTarget = this.productParentElement.querySelector(
        'product-form [data-variant-dynamic="variant-price"]'
      );
      const savedLabel = priceTarget?.dataset.savedLabel || 'saved';
      const perMeterSuffix = priceTarget?.dataset.perMeterSuffix || '/m';
      return `<span class="rounded-full bg-white px-2 pt-1 pb-0.5 flex items-end gap-1 w-fit text-primary hidden!"><span class="text-ui-small font-medium">${this.#formatMoney(pricePerMeter)}${perMeterSuffix} <span class="opacity-50">${savingsPercentage}% ${savedLabel}</span></span></span>`;
    }

    /**
     * Parse numeric meters from a length option label.
     * @param {string} value - Length label, e.g. "2 Meter", "7.5 Meter"
     * @returns {number} Parsed meters value or 0
     * @private
     */
    #extractMetersFromLengthValue(value) {
      if (typeof value !== "string") {
        return 0;
      }

      const normalized = value
        .replace(",", ".")
        .replace(/[^0-9.]/g, "")
        .trim();
      const parsed = Number.parseFloat(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    /**
     * Closest available length radio to the remembered length.
     * @param {Array<HTMLInputElement>} radios - Length radios
     * @param {string} preferredValue - Remembered length label
     * @returns {HTMLInputElement|null}
     * @private
     */
    #pickClosestAvailableLengthRadio(radios, preferredValue) {
      const available = radios.filter((radio) => (
        !radio.disabled && radio.getAttribute("available") === "true"
      ));
      if (available.length === 0) {
        return null;
      }

      const preferredMeters = this.#extractMetersFromLengthValue(preferredValue);
      if (preferredMeters <= 0) {
        return available[0];
      }

      let closest = available[0];
      let closestDelta = Infinity;
      available.forEach((radio) => {
        const meters = this.#extractMetersFromLengthValue(radio.value);
        const delta = Math.abs(meters - preferredMeters);
        if (delta < closestDelta) {
          closestDelta = delta;
          closest = radio;
        }
      });

      return closest;
    }

    /**
     * Shortest selectable length radio.
     * @param {Array<HTMLInputElement>} radios
     * @returns {HTMLInputElement|null}
     * @private
     */
    #pickSmallestAvailableLengthRadio(radios) {
      const available = radios.filter((radio) => (
        !radio.disabled && radio.getAttribute("available") === "true"
      ));
      if (available.length === 0) {
        return null;
      }

      let smallest = available[0];
      let smallestMeters = this.#extractMetersFromLengthValue(smallest.value);
      available.forEach((radio) => {
        const meters = this.#extractMetersFromLengthValue(radio.value);
        if (meters > 0 && (smallestMeters <= 0 || meters < smallestMeters)) {
          smallest = radio;
          smallestMeters = meters;
        }
      });

      return smallest;
    }

    /**
     * Parse numeric meters value from a variant option.
     * @param {Object|null} variant - Variant object
     * @param {number} optionIndex - Length option index
     * @returns {number} Parsed meters value or 0
     * @private
     */
    #extractMetersFromVariantOption(variant, optionIndex) {
      if (!variant || !Array.isArray(variant.options) || optionIndex < 0) {
        return 0;
      }

      const resolved = this.#resolveSourceOptionIndex(variant, optionIndex);
      const rawOption = resolved.exists
        ? variant.options[resolved.index]
        : variant.options[optionIndex];
      return this.#extractMetersFromLengthValue(rawOption);
    }

    /**
     * Format cents using locale/currency data available on the storefront.
     * @param {number|string} cents - Amount in cents
     * @returns {string} Formatted money text
     * @private
     */
    #formatMoney(cents) {
      const amount = Number(cents);
      if (!Number.isFinite(amount)) {
        return "";
      }

      const locale = document.documentElement.lang || "en";
      const currency =
        window.Shopify?.currency?.active || window.Shopify?.currency?.code || "EUR";

      /** CLDR uses "kr" for these; force ISO codes for clearer storefront labeling. */
      const useCurrencyCode =
        currency === "NOK" || currency === "DKK" || currency === "SEK";

      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
          ...(useCurrencyCode ? { currencyDisplay: "code" } : {}),
        }).format(amount / 100);
      } catch (error) {
        return `${(amount / 100).toFixed(2)} ${currency}`;
      }
    }

    /**
     * Refresh nested length slider UI after radio availability changes.
     * @private
     */
    #refreshLengthSliderState() {
      const lengthSliders = this.querySelectorAll('length-slider');
      lengthSliders.forEach((slider) => {
        if (typeof slider.refreshFromRadios === 'function') {
          slider.refreshFromRadios();
        }
      });
    }

    updateStickyOutput() {
      if (!this.stickyOutput) return;

      const currentVariant = this.#getSelectedVariantFromOptions() || this.getCurrentVariant();
      if (!currentVariant) return;

      try {
        this.stickyOutput.innerHTML = currentVariant.title || '';
        if (this.stickyImageOutput && currentVariant.featured_image?.src) {
          this.stickyImageOutput.src = currentVariant.featured_image.src;
        }
      } catch (error) {}
    }

    /**
     * Update the current product URL based on selected options (for combined listings).
     *
     * Checks option groups in order (0, 1, 2...). The first option that resolves to a URL
     * different from the current page determines `currentProductUrl`. This ensures the
     * primary product-family option always takes priority, while Shopify's `option_values`
     * param handles the concrete variant selection inside that product.
     */
    updateCurrentProductUrl() {
      if (!this.options) {
        this.currentProductUrl = null;
        this.currentTargetVariantId = null;
        return;
      }

      try {
        const currentPageUrl = this.#normalizeProductUrl(this.dataset.url);
        // this.#logSelectedRadioTargets();
        // const selectionCandidates = this.#getSelectionCandidates(this.options);
        // this.#logSelectionCandidates(this.options, selectionCandidates);
        const resolvedTarget = this.#resolveSelectionTarget(this.options);

        if (this.combinedListingsMap?.length) {
          if (resolvedTarget?.url) {
            const resolvedUrl = this.#normalizeProductUrl(resolvedTarget.url);
            this.currentProductUrl = resolvedTarget.url;
            this.currentTargetVariantId = resolvedTarget.variantId || null;

            if (resolvedUrl === currentPageUrl && !this.currentTargetVariantId) {
              this.currentProductUrl = this.dataset.url;
            }

            return;
          }

          // Combined-listings-map couldn't resolve a target — the map may not contain
          // entries for the selected product (e.g. switching Schuko → CEE across products).
          // Fall back to the checked radio's data-product-url for cross-product navigation.
          const radioFallback = this.#getCheckedRadioCrossProductUrl(currentPageUrl);
          if (radioFallback) {
            this.currentProductUrl = radioFallback.url;
            this.currentTargetVariantId = radioFallback.variantId || null;
            return;
          }

          this.currentProductUrl = null;
          this.currentTargetVariantId = null;
          return;
        }

        this.currentTargetVariantId = null;

        if (!this.optionUrls) {
          this.currentProductUrl = null;
          return;
        }

        for (let optionIndex = 0; optionIndex < this.options.length; optionIndex++) {
          const selectedValue = this.options[optionIndex];
          if (!selectedValue) continue;

          const fieldset = this.fieldsets[optionIndex];
          if (!fieldset || !this.optionUrls[optionIndex]) continue;

          const radios = [...fieldset.elements].filter(el => el.type === 'radio');
          const optionValues = radios.map(radio => radio.value);

          const selectedIndex = optionValues.findIndex(value => {
            const normalizedValue = typeof value === 'string' ? value.trim() : value;
            const normalizedSelected = typeof selectedValue === 'string' ? selectedValue.trim() : selectedValue;
            return normalizedValue === normalizedSelected;
          });

          if (selectedIndex >= 0 && selectedIndex < this.optionUrls[optionIndex].length) {
            const url = this.optionUrls[optionIndex][selectedIndex];
            if (url && typeof url === 'string' && url.trim() !== '') {
              const trimmedUrl = url.trim();
              if (this.#normalizeProductUrl(trimmedUrl) !== currentPageUrl) {
                // First cross-product option wins — it defines the product family URL
                this.currentProductUrl = trimmedUrl;
                return;
              }
              // Same page — keep scanning higher option groups
            }
          }
        }

        this.currentProductUrl = null;
      } catch (error) {
        this.currentProductUrl = null;
        this.currentTargetVariantId = null;
      }
    }

    /**
     * Check checked radios for a data-product-url pointing to a different product.
     * Used as a fallback when the combined-listings-map has no entries for the target.
     * @param {string} currentPageUrl - Normalized current page URL
     * @returns {{ url: string, variantId: string|null }|null}
     * @private
     */
    #getCheckedRadioCrossProductUrl(currentPageUrl) {
      if (!Array.isArray(this.fieldsets)) return null;

      for (const fieldset of this.fieldsets) {
        const checked = [...fieldset.elements].find((r) => r.type === 'radio' && r.checked);
        if (!checked?.dataset.productUrl) continue;

        const radioUrl = checked.dataset.productUrl.trim();
        if (!radioUrl) continue;

        const normalized = this.#normalizeProductUrl(radioUrl);
        if (normalized && normalized !== currentPageUrl) {
          return {
            url: radioUrl,
            variantId: checked.dataset.targetVariantId || null
          };
        }
      }

      return null;
    }

    /**
     * Resolve the linked product URL for a radio option in combined listings.
     * @param {HTMLFieldSetElement} fieldset - Fieldset containing the radio
     * @param {number} optionIndex - Option group index
     * @param {HTMLInputElement} radio - Radio input to resolve
     * @returns {string|null} Linked product URL or null
     * @private
     */
    #getOptionUrlForRadio(fieldset, optionIndex, radio) {
      if (!fieldset || !radio) {
        return null;
      }

      const explicitUrl = typeof radio.dataset.productUrl === "string" ? radio.dataset.productUrl.trim() : "";
      if (explicitUrl) {
        return explicitUrl;
      }

      if (!this.optionUrls?.[optionIndex]) {
        return null;
      }

      const radios = [...fieldset.elements].filter((element) => element.type === 'radio');
      const optionValues = radios.map((element) => element.value);
      const selectedIndex = optionValues.findIndex((value) => {
        const normalizedValue = typeof value === 'string' ? value.trim() : value;
        const normalizedRadioValue = typeof radio.value === 'string' ? radio.value.trim() : radio.value;
        return normalizedValue === normalizedRadioValue;
      });

      if (selectedIndex < 0 || selectedIndex >= this.optionUrls[optionIndex].length) {
        return null;
      }

      const url = this.optionUrls[optionIndex][selectedIndex];
      return typeof url === 'string' && url.trim() !== '' ? url.trim() : null;
    }

    /**
     * Resolve the linked target variant ID for a radio option.
     * @param {HTMLFieldSetElement} fieldset - Fieldset containing the radio
     * @param {number} optionIndex - Option group index
     * @param {HTMLInputElement} radio - Radio input to resolve
     * @returns {string|null} Linked target variant ID or null
     * @private
     */
    #getOptionTargetVariantIdForRadio(fieldset, optionIndex, radio) {
      if (!fieldset || !radio) {
        return null;
      }

      const explicitVariantId = typeof radio.dataset.targetVariantId === "string"
        ? radio.dataset.targetVariantId.trim()
        : "";
      if (explicitVariantId) {
        return explicitVariantId;
      }

      return null;
    }

    /**
     * Resolve the product URL implied by the currently selected option radios.
     * The first selected cross-product option wins and becomes the active product context.
     * @returns {string} Selected product URL or empty string
     * @private
     */
    #getSelectedOptionProductUrl() {
      if (this.explicitProductUrl && !this.#hasCompleteSelection()) {
        return this.explicitProductUrl;
      }

      if (!Array.isArray(this.fieldsets) || !Array.isArray(this.options)) {
        return "";
      }

      for (let optionIndex = 0; optionIndex < this.options.length; optionIndex++) {
        const selectedValue = this.options[optionIndex];
        if (!selectedValue) continue;

        const fieldset = this.fieldsets[optionIndex];
        if (!fieldset) continue;

        const selectedRadio = [...fieldset.elements].find((radio) => (
          radio.type === "radio" && radio.checked && radio.value === selectedValue
        ));
        if (!selectedRadio) continue;

        const optionUrl = this.#getOptionUrlForRadio(fieldset, optionIndex, selectedRadio);
        if (optionUrl) {
          return optionUrl;
        }
      }

      return "";
    }

    /**
     * Check whether a provided option set is complete.
     * @param {Array<string|null>} optionSet - Option values to validate
     * @returns {boolean} True when every option has a non-empty value
     * @private
     */
    #hasCompleteOptionSet(optionSet) {
      if (!Array.isArray(optionSet) || optionSet.length === 0 || !Array.isArray(this.fieldsets)) {
        return false;
      }

      return this.fieldsets.every((fieldset, index) => {
        if (fieldset?.hidden) {
          return true;
        }
        if (!this.#optionExistsOnCurrentProduct(index)) {
          return true;
        }

        const option = optionSet[index];
        return typeof option === "string" && option.trim() !== "";
      });
    }

    /**
     * Count selected non-empty option values.
     * @param {Array<string|null>} optionSet - Option values to inspect
     * @returns {number} Number of selected options
     * @private
     */
    #countSelectedOptions(optionSet) {
      if (!Array.isArray(optionSet)) {
        return 0;
      }

      return optionSet.filter((option) => typeof option === "string" && option.trim() !== "").length;
    }

    /**
     * Build a stable key for an option combination.
     * @param {Array<string|null>} optionSet - Option values
     * @returns {string} Serialized option key
     * @private
     */
    #buildSelectionKey(optionSet) {
      if (!Array.isArray(optionSet) || optionSet.length === 0) {
        return "";
      }

      return optionSet.map((option) => (
        typeof option === "string" ? option.trim() : ""
      )).join("|||");
    }

    /**
     * Get all target candidates that match the current selected options.
     * @param {Array<string>} [selectedOptions=this.options] - Selected option values
     * @returns {Array<Object>} Matching target candidates
     * @private
     */
    #getSelectionCandidates(selectedOptions = this.options) {
      if (!Array.isArray(selectedOptions) || selectedOptions.length === 0) {
        return [];
      }

      if (this.#hasCompleteOptionSet(selectedOptions) && this.selectionLinkIndex instanceof Map) {
        const key = this.#buildSelectionKey(selectedOptions);
        const exactCandidates = this.selectionLinkIndex.get(key) || [];
        if (exactCandidates.length > 0) {
          return exactCandidates;
        }
      }

      if (!Array.isArray(this.combinedListingsMap)) {
        return [];
      }

      return this.combinedListingsMap.filter((entry) => (
        this.#sourceMatchesTestOptions(entry, selectedOptions)
      ));
    }

    /**
     * Log the current selection candidates to the browser console for debugging.
     * @param {Array<string>} selectedOptions - Selected option values
     * @param {Array<Object>} candidates - Matching target candidates
     * @private
     */
    #logSelectionCandidates(selectedOptions, candidates) {
      const formattedCandidates = Array.isArray(candidates)
        ? candidates.map((entry) => ({
          url: entry?.url || null,
          variantId: entry?.variantId || null,
          available: entry?.available ?? null,
          options: Array.isArray(entry?.options) ? entry.options.join(" | ") : null,
        }))
        : [];

      console.info("[variant-radios] selection candidates", {
        selectedOptions,
        candidateCount: formattedCandidates.length,
        candidates: formattedCandidates,
      });
    }

    /**
     * Log the currently selected radios and their resolved link data.
     * @private
     */
    #logSelectedRadioTargets() {
      if (!Array.isArray(this.fieldsets)) {
        return;
      }

      const selectedRadios = [];

      this.fieldsets.forEach((fieldset, fieldsetIndex) => {
        const selectedRadio = [...fieldset.elements].find((radio) => radio.type === "radio" && radio.checked);
        if (!selectedRadio) {
          selectedRadios.push({
            fieldsetIndex,
            value: null,
            productUrl: null,
            targetVariantId: null,
          });
          return;
        }

        selectedRadios.push({
          fieldsetIndex,
          value: selectedRadio.value,
          productUrl: this.#getOptionUrlForRadio(fieldset, fieldsetIndex, selectedRadio),
          targetVariantId: this.#getOptionTargetVariantIdForRadio(fieldset, fieldsetIndex, selectedRadio),
        });
      });

      console.info("[variant-radios] selected radio targets", selectedRadios);
    }

    /**
     * Resolve the canonical target product for the current selection.
     * Uses exact selection links when all options are chosen and falls back to the
     * selected option URL while the user is still building the combination.
     * @param {Array<string>} [selectedOptions=this.options] - Selected option values
     * @returns {Object|null} Resolved target entry with url and variantId
     * @private
     */
    #resolveSelectionTarget(selectedOptions = this.options) {
      if (!Array.isArray(selectedOptions) || selectedOptions.length === 0) {
        return null;
      }

      const candidates = this.#getSelectionCandidates(selectedOptions);
      if (!candidates.length) {
        return null;
      }

      const uniqueUrls = [...new Set(
        candidates
          .map((entry) => this.#normalizeProductUrl(entry?.url))
          .filter(Boolean)
      )];

      if (uniqueUrls.length !== 1) {
        return null;
      }

      const targetUrl = uniqueUrls[0];
      const urlCandidates = candidates.filter((entry) => this.#normalizeProductUrl(entry?.url) === targetUrl);
      const availableCandidates = urlCandidates.filter((entry) => entry.available === true);
      const explicitTargetVariantId = this.explicitTargetVariantId ? String(this.explicitTargetVariantId) : "";
      const currentTargetVariantId = this.currentTargetVariantId ? String(this.currentTargetVariantId) : "";
      const winner = availableCandidates.find((entry) => explicitTargetVariantId && String(entry.variantId) === explicitTargetVariantId)
        || availableCandidates.find((entry) => currentTargetVariantId && String(entry.variantId) === currentTargetVariantId)
        || availableCandidates[0]
        || urlCandidates.find((entry) => explicitTargetVariantId && String(entry.variantId) === explicitTargetVariantId)
        || urlCandidates.find((entry) => currentTargetVariantId && String(entry.variantId) === currentTargetVariantId)
        || urlCandidates[0];

      return winner || null;
    }

    /**
     * Resolve the best combined-listing entry for the current selection.
     * Tries exact selection first, then progressively relaxes trailing options
     * so switching product families still works when the current length does not exist there.
     * @returns {Object|null} Matching combined listing entry
     * @private
     */
    #getBestCombinedListingMatch(selectedOptions = this.options) {
      if (!Array.isArray(selectedOptions) || !Array.isArray(this.combinedListingsMap) || this.combinedListingsMap.length === 0) {
        return null;
      }

      const normalizedSelectedOptions = [...selectedOptions];
      const selectedCount = this.#countSelectedOptions(normalizedSelectedOptions);
      const explicitSelectedUrl = this.#hasCompleteOptionSet(selectedOptions)
        || selectedCount > 1
        ? ""
        : this.#normalizeProductUrl(this.#getSelectedOptionProductUrl());
      const preferredUrl = this.#normalizeProductUrl(
        this.#getPreferredProductUrlForSelection(normalizedSelectedOptions) || this.currentProductUrl || this.dataset.url
      );

      for (let end = normalizedSelectedOptions.length; end > 0; end--) {
        const candidateOptions = normalizedSelectedOptions.map((option, index) => (index < end ? option : ''));
        const matches = this.combinedListingsMap.filter((entry) => (
          this.#sourceMatchesTestOptions(entry, candidateOptions)
        ));

        if (matches.length > 0) {
          return matches.find((entry) => explicitSelectedUrl && this.#normalizeProductUrl(entry.url) === explicitSelectedUrl)
            || matches.find((entry) => entry.available === true && this.#normalizeProductUrl(entry.url) === preferredUrl)
            || matches.find((entry) => this.#normalizeProductUrl(entry.url) === preferredUrl)
            || matches.find((entry) => entry.available === true)
            || matches[0];
        }
      }

      return null;
    }

    /**
     * Get all variants that match the current test option set.
     * Null/empty options are ignored so partial selections still work.
     * @param {Array<string|null>} testOptions - Option values to match
     * @param {Array<Object>} allVariants - Variant dataset
     * @returns {Array<Object>} Matching variants
     * @private
     */
    #getMatchingVariants(testOptions, allVariants, requiredFieldsetIndex = -1) {
      if (!Array.isArray(testOptions) || !Array.isArray(allVariants)) {
        return [];
      }

      return allVariants.filter((variant) => (
        this.#sourceMatchesTestOptions(variant, testOptions, requiredFieldsetIndex)
      ));
    }

    /**
     * Get combined-listing entries that match a partial option set.
     * Null/empty options are ignored so upstream selections can drive downstream availability.
     * @param {Array<string|null>} testOptions - Option values to match
     * @returns {Array<Object>} Matching combined listing entries
     * @private
     */
    #getMatchingCombinedListings(testOptions, requiredFieldsetIndex = -1) {
      if (!Array.isArray(testOptions) || !Array.isArray(this.combinedListingsMap)) {
        return [];
      }

      const matches = this.combinedListingsMap.filter((entry) => (
        this.#sourceMatchesTestOptions(entry, testOptions, requiredFieldsetIndex)
      ));

      const explicitUrl = this.#normalizeProductUrl(this.explicitProductUrl);
      const shouldPinExplicitUrl = !!explicitUrl && !this.#hasCompleteOptionSet(testOptions);
      if (!shouldPinExplicitUrl) {
        return matches;
      }

      const explicitMatches = matches.filter((entry) => this.#normalizeProductUrl(entry.url) === explicitUrl);
      return explicitMatches.length > 0 ? explicitMatches : matches;
    }

    /**
     * Build the option set used to evaluate a fieldset radio.
     * Only upstream selections are locked so earlier changes can repopulate downstream choices.
     * Indices listed in excludeIndices are always nulled out regardless of position.
     * @param {Array<string|null>} selectedOptions - Current selected option values
     * @param {number} fieldsetIndex - Fieldset index being evaluated
     * @param {string} radioValue - Candidate radio value
     * @param {Array<number>} [excludeIndices=[]] - Option indices to ignore (always null)
     * @returns {Array<string|null>} Prefix-based option set
     * @private
     */
    #buildAvailabilityTestOptions(selectedOptions, fieldsetIndex, radioValue, excludeIndices = []) {
      if (!Array.isArray(selectedOptions)) {
        return [];
      }

      return selectedOptions.map((option, index) => {
        if (excludeIndices.includes(index)) {
          return null;
        }

        if (index < fieldsetIndex) {
          return option;
        }

        if (index === fieldsetIndex) {
          return radioValue;
        }

        return null;
      });
    }

    /**
     * Apply visual availability state to a radio and its label.
     * On the last non-length fieldset, unavailable options are hidden entirely.
     * On other fieldsets they are dimmed.
     * @param {HTMLInputElement} radio
     * @param {HTMLLabelElement|null} optionLabel
     * @param {boolean} isAvailable
     * @param {boolean} hideWhenUnavailable
     * @private
     */
    #applyAvailabilityStyles(radio, optionLabel, isAvailable, hideWhenUnavailable) {
      const wrapper = radio.parentElement;

      if (isAvailable) {
        radio.classList.remove('disabled');
        wrapper?.classList.remove('disabled');
        if (wrapper) wrapper.hidden = false;
        if (optionLabel) {
          optionLabel.style.opacity = '';
          optionLabel.style.textDecoration = '';
        }
      } else if (hideWhenUnavailable) {
        radio.classList.add('disabled');
        wrapper?.classList.add('disabled');
        if (wrapper) wrapper.hidden = true;
      } else {
        radio.classList.add('disabled');
        wrapper?.classList.add('disabled');
        if (wrapper) wrapper.hidden = false;
        if (optionLabel) {
          optionLabel.style.opacity = '0.5';
          optionLabel.style.textDecoration = 'none';
        }
      }
    }

    /**
     * Find the option index rendered as the length selector.
     * @returns {number} Length option index or -1 when absent
     * @private
     */
    #getLengthOptionIndex() {
      if (!Array.isArray(this.fieldsets)) {
        return -1;
      }

      return this.fieldsets.findIndex((fieldset) => fieldset.closest("length-slider"));
    }

    /**
     * Last option group that should hide unavailable values (power, not Set/length).
     * @returns {number}
     * @private
     */
    #getLastNonLengthFieldsetIndex() {
      const lengthOptionIndex = this.#getLengthOptionIndex();
      for (let i = this.fieldsets.length - 1; i >= 0; i--) {
        if (i === lengthOptionIndex) {
          continue;
        }
        if (this.fieldsets[i]?.closest("length-slider")) {
          continue;
        }
        if (!this.#optionExistsOnCurrentProduct(i)) {
          continue;
        }
        return i;
      }

      return lengthOptionIndex > 0 ? lengthOptionIndex - 1 : -1;
    }

    /**
     * Selected Type (first fieldset) value.
     * @returns {string}
     * @private
     */
    #getSelectedTypeValue() {
      const typeFieldset = this.fieldsets[0];
      if (!typeFieldset) {
        return "";
      }

      const checked = [...typeFieldset.elements].find((radio) => radio.type === "radio" && radio.checked);
      return checked ? checked.value : "";
    }

    /**
     * Combined-listing entry for the product family currently selected (Type),
     * not the previously rendered child (OCPP while clicking Schuko).
     * @returns {Object|null}
     * @private
     */
    #getTargetListingSource() {
      if (!Array.isArray(this.combinedListingsMap) || this.combinedListingsMap.length === 0) {
        return this.getCurrentVariant();
      }

      const typeValue = this.#getSelectedTypeValue();
      const typeMatches = typeValue
        ? this.combinedListingsMap.filter((entry) => {
          if (!Array.isArray(entry?.options)) {
            return false;
          }
          const resolved = this.#resolveSourceOptionIndex(entry, 0);
          return resolved.exists && entry.options[resolved.index] === typeValue;
        })
        : [];

      if (typeMatches.length > 0) {
        const targetUrl = this.#normalizeProductUrl(
          this.explicitProductUrl || this.currentProductUrl || ""
        );
        if (targetUrl) {
          const urlMatch = typeMatches.find(
            (entry) => this.#normalizeProductUrl(entry.url) === targetUrl
          );
          if (urlMatch) {
            return urlMatch;
          }
        }
        return typeMatches[0];
      }

      return this.getCurrentVariant();
    }

    /**
     * Whether radios in a fieldset point at more than one product URL.
     * @param {HTMLFieldSetElement} fieldset
     * @param {number} fieldsetIndex
     * @returns {boolean}
     * @private
     */
    #fieldsetHasDistinctProductUrls(fieldset, fieldsetIndex) {
      if (!fieldset) {
        return false;
      }

      const urls = new Set();
      [...fieldset.elements].forEach((radio) => {
        if (radio.type !== "radio") {
          return;
        }
        const url = this.#normalizeProductUrl(
          this.#getOptionUrlForRadio(fieldset, fieldsetIndex, radio) || ""
        );
        if (url) {
          urls.add(url);
        }
      });

      return urls.size > 1;
    }

    /**
     * Option names currently rendered as fieldsets (listing-level, may include Set).
     * @returns {Array<string>}
     * @private
     */
    #getFieldsetOptionNames() {
      if (!Array.isArray(this.fieldsets)) {
        return [];
      }

      return this.fieldsets.map((fieldset) => {
        const fromFieldset = typeof fieldset.dataset?.optionName === "string"
          ? fieldset.dataset.optionName.trim()
          : "";
        if (fromFieldset) {
          return fromFieldset;
        }

        const slider = fieldset.closest("length-slider");
        const fromSlider = typeof slider?.dataset?.optionName === "string"
          ? slider.dataset.optionName.trim()
          : "";
        return fromSlider;
      });
    }

    /**
     * Whether the current child product natively has this fieldset's option.
     * Combined listings can render Set on products that do not own that option.
     * @param {number} fieldsetIndex
     * @returns {boolean}
     * @private
     */
    #optionExistsOnCurrentProduct(fieldsetIndex) {
      const target = this.#getTargetListingSource();
      if (target && Array.isArray(target.options) && target.options.length > 0) {
        return this.#resolveSourceOptionIndex(target, fieldsetIndex).exists;
      }

      const current = this.getCurrentVariant();
      if (current && Array.isArray(current.options) && current.options.length > 0) {
        return this.#resolveSourceOptionIndex(current, fieldsetIndex).exists;
      }

      const names = this.#getFieldsetOptionNames();
      const name = names[fieldsetIndex];
      if (!name) {
        return true;
      }
      if (!Array.isArray(this.productOptionNames) || this.productOptionNames.length === 0) {
        return true;
      }
      return findOptionNameIndex(this.productOptionNames, name) >= 0;
    }

    /**
     * Option names for a variant JSON object or combined-listing map entry.
     * @param {Object} source
     * @returns {Array<string>}
     * @private
     */
    #getOptionNamesForSource(source) {
      if (Array.isArray(source?.optionNames) && source.optionNames.length) {
        return source.optionNames;
      }

      const variantId = source?.id ?? source?.variantId;
      if (variantId != null && Array.isArray(this.combinedListingsMap)) {
        const entry = this.combinedListingsMap.find(
          (item) => String(item?.variantId) === String(variantId)
        );
        if (Array.isArray(entry?.optionNames) && entry.optionNames.length) {
          return entry.optionNames;
        }
      }

      if (
        Array.isArray(this.productOptionNames)
        && this.productOptionNames.length > 0
        && Array.isArray(source?.options)
        && source.options.length === this.productOptionNames.length
      ) {
        return this.productOptionNames;
      }

      return [];
    }

    /**
     * Combined-listing children can carry a trailing Shopify "Default Title"
     * value that is not rendered as a fieldset. Strip it only when other real
     * option values remain — never empty a single-/default-variant product.
     * @param {Object} source
     * @returns {Array<string>}
     * @private
     */
    #getSourceOptionValues(source) {
      if (!Array.isArray(source?.options)) {
        return [];
      }

      const values = [...source.options];
      while (
        values.length > 1
        && this.#isPlaceholderOptionValue(values[values.length - 1])
      ) {
        values.pop();
      }
      return values;
    }

    /**
     * @param {string} value
     * @returns {boolean}
     * @private
     */
    #isPlaceholderOptionValue(value) {
      return typeof value === "string" && value.trim().toLowerCase() === "default title";
    }

    /**
     * Map a rendered fieldset onto a variant/entry options array.
     * Named lookup first; if names are missing, extra options sit before length (last).
     * @param {Object} source
     * @param {number} fieldsetIndex
     * @returns {{ exists: boolean, index: number }}
     * @private
     */
    #resolveSourceOptionIndex(source, fieldsetIndex) {
      const optionValues = this.#getSourceOptionValues(source);
      if (!Array.isArray(optionValues) || optionValues.length === 0 || fieldsetIndex < 0) {
        return { exists: false, index: -1 };
      }

      const fieldsetNames = this.#getFieldsetOptionNames();
      const optionNames = this.#getOptionNamesForSource(source);
      const fieldsetName = fieldsetNames[fieldsetIndex] || "";

      // Named lookup is only safe when names and values are the same length.
      // Combined-listing children can have listing names (5) but child values (4);
      // using the listing index then reads past the array or hits Set's slot as length.
      if (
        fieldsetName
        && optionNames.length > 0
        && optionNames.length === optionValues.length
      ) {
        const index = findOptionNameIndex(optionNames, fieldsetName);
        return index >= 0 ? { exists: true, index } : { exists: false, index: -1 };
      }

      if (optionValues.length === fieldsetNames.length) {
        return fieldsetIndex < optionValues.length
          ? { exists: true, index: fieldsetIndex }
          : { exists: false, index: -1 };
      }

      const fieldsetCount = fieldsetNames.length || 0;
      if (fieldsetCount === 0) {
        return fieldsetIndex < optionValues.length
          ? { exists: true, index: fieldsetIndex }
          : { exists: false, index: -1 };
      }

      if (fieldsetIndex === fieldsetCount - 1) {
        return { exists: true, index: optionValues.length - 1 };
      }

      const sharedPrefix = Math.min(fieldsetCount, optionValues.length) - 1;
      if (fieldsetIndex < sharedPrefix) {
        return { exists: true, index: fieldsetIndex };
      }

      return { exists: false, index: -1 };
    }

    /**
     * Whether a variant/listing entry matches the given fieldset values.
     * Options the source product does not have are skipped, unless that fieldset
     * is currently being evaluated (requiredFieldsetIndex).
     * @param {Object} source
     * @param {Array<string|null>} testOptions
     * @param {number} [requiredFieldsetIndex=-1]
     * @returns {boolean}
     * @private
     */
    #sourceMatchesTestOptions(source, testOptions, requiredFieldsetIndex = -1) {
      const optionValues = this.#getSourceOptionValues(source);
      if (!source || optionValues.length === 0 || !Array.isArray(testOptions)) {
        return false;
      }

      for (let i = 0; i < testOptions.length; i++) {
        const testOpt = testOptions[i];
        if (testOpt === null || testOpt === undefined || testOpt === "") {
          continue;
        }

        const resolved = this.#resolveSourceOptionIndex(source, i);
        if (!resolved.exists) {
          if (i === requiredFieldsetIndex) {
            return false;
          }
          continue;
        }

        if (optionValues[resolved.index] !== testOpt) {
          return false;
        }
      }

      return true;
    }

    /**
     * Resolve the preferred product URL for the current non-length selections.
     * This keeps length changes anchored to the product family chosen by the other options.
     * @param {Array<string>} [selectedOptions=this.options] - Selected option values
     * @returns {string} Preferred product URL or empty string
     * @private
     */
    #getPreferredProductUrlForSelection(selectedOptions = this.options) {
      if (!Array.isArray(selectedOptions) || !Array.isArray(this.combinedListingsMap) || !this.combinedListingsMap.length) {
        return "";
      }

      const selectedOptionUrl = this.#getSelectedOptionProductUrl();
      if (selectedOptionUrl) {
        return selectedOptionUrl;
      }

      const lengthOptionIndex = this.#getLengthOptionIndex();
      if (lengthOptionIndex < 0 || !selectedOptions[lengthOptionIndex]) {
        return "";
      }

      const nonLengthOptions = selectedOptions.map((option, index) => (
        index === lengthOptionIndex ? null : option
      ));
      const matches = this.#getMatchingCombinedListings(nonLengthOptions);

      if (!matches.length) {
        return "";
      }

      const currentUrl = this.#normalizeProductUrl(this.currentProductUrl || this.dataset.url);
      const preferredMatch = matches.find((entry) => this.#normalizeProductUrl(entry.url) === currentUrl)
        || matches.find((entry) => entry.available === true)
        || matches[0];

      return preferredMatch?.url || "";
    }

    /**
     * Normalize product URLs so cross-product comparisons stay consistent.
     * @param {string} rawUrl - URL to normalize
     * @returns {string} Normalized pathname
     * @private
     */
    #normalizeProductUrl(rawUrl) {
      if (typeof rawUrl !== "string" || rawUrl.trim() === "") {
        return "";
      }

      try {
        const url = new URL(rawUrl, window.location.origin);
        const pathname = url.pathname.replace(/\/+$/, "");
        return pathname || "/";
      } catch (error) {
        const trimmedUrl = rawUrl.trim().replace(window.location.origin, "");
        const pathname = trimmedUrl.replace(/\/+$/, "");
        return pathname || "/";
      }
    }

    /**
     * Find a variant in the collected variant dataset by ID.
     * @param {number|string} variantId - Variant ID to resolve
     * @param {Array<Object>} allVariants - Variant dataset
     * @returns {Object|null} Matching variant object
     * @private
     */
    #findVariantById(variantId, allVariants) {
      if (!variantId || !Array.isArray(allVariants)) {
        return null;
      }

      const normalizedVariantId = String(variantId);
      return allVariants.find((variant) => String(variant?.id) === normalizedVariantId) || null;
    }

    /**
     * Resolve the exact combined-listing entry for the current full selection.
     * When duplicate option combinations exist, prefer the explicitly targeted entry,
     * then the current product context, and finally an available entry.
     * @param {Array<string>} [selectedOptions=this.options] - Selected option values
     * @returns {Object|null} Matching combined-listing entry
     * @private
     */
    #getExactCombinedListingMatch(selectedOptions = this.options) {
      if (!Array.isArray(selectedOptions) || !selectedOptions.length) {
        return null;
      }

      const matches = this.#getMatchingCombinedListings(selectedOptions).filter((entry) => {
        if (!entry || !Array.isArray(entry.options)) {
          return false;
        }

        const fieldsetNames = this.#getFieldsetOptionNames();
        for (let i = 0; i < fieldsetNames.length; i++) {
          const resolved = this.#resolveSourceOptionIndex(entry, i);
          if (!resolved.exists) {
            continue;
          }

          const selected = selectedOptions[i];
          if (typeof selected !== "string" || selected.trim() === "") {
            return false;
          }

          const optionValues = this.#getSourceOptionValues(entry);
          if (optionValues[resolved.index] !== selected) {
            return false;
          }
        }

        return true;
      });

      if (!matches.length) {
        return null;
      }

      const targetVariantId = this.currentTargetVariantId ? String(this.currentTargetVariantId) : "";
      const preferredUrl = this.#normalizeProductUrl(
        this.#getPreferredProductUrlForSelection(selectedOptions) || this.currentProductUrl || this.dataset.url
      );
      const availableMatches = matches.filter((entry) => entry.available === true);

      return availableMatches.find((entry) => targetVariantId && String(entry.variantId) === targetVariantId)
        || availableMatches.find((entry) => this.#normalizeProductUrl(entry.url) === preferredUrl)
        || availableMatches[0]
        || matches.find((entry) => this.#normalizeProductUrl(entry.url) === preferredUrl && targetVariantId && String(entry.variantId) === targetVariantId)
        || matches.find((entry) => this.#normalizeProductUrl(entry.url) === preferredUrl)
        || matches.find((entry) => targetVariantId && String(entry.variantId) === targetVariantId)
        || matches[0];
    }

    updateOptions() {
      // Refresh fieldsets in case DOM was replaced
      this.fieldsets = [...this.querySelectorAll("fieldset")];

      // Get currently selected value from each fieldset
      this.options = this.fieldsets.map((fieldset) => {
        const checkedRadio = [...fieldset.elements].find((radio) => radio.checked && radio.type === 'radio');
        return checkedRadio ? checkedRadio.value : "";
      });
    }

    /**
     * Update availability states for all variant options
     * Cascading availability: First fieldset is always standard, second checks first,
     * third checks first+second, fourth checks first+second+third
     *
     * For combined listings: Check if option combination exists in any child product
     * For regular variants: Check variant data for availability
     */
    updateVariantsAvailability(changedFieldsetIndex = -1, pass = 0) {
      // Get all variants from JSON
      const allVariants = this.#getAllVariants();
      if (!allVariants || allVariants.length === 0) return;
      if (pass > this.fieldsets.length) return;
      let selectionChanged = false;

      // Get currently selected options
      const selectedOptions = this.fieldsets.map((fieldset) => {
        const checked = [...fieldset.elements].find((radio) => radio.checked && radio.type === 'radio');
        return checked ? checked.value : null;
      });

      const useCombinedListings = Array.isArray(this.combinedListingsMap) && this.combinedListingsMap.length > 0;

      // The length option should never constrain availability of other option groups.
      // Extra listing options the target product does not own (Set) are excluded too.
      const lengthOptionIndex = this.#getLengthOptionIndex();
      const lastNonLengthIndex = this.#getLastNonLengthFieldsetIndex();
      const targetListingUrl = this.#normalizeProductUrl(
        this.#getTargetListingSource()?.url || this.explicitProductUrl || this.currentProductUrl || ""
      );

      // For each fieldset, check which options are available
      this.fieldsets.forEach((fieldset, fieldsetIndex) => {
        const excludeIndices = [];
        if (lengthOptionIndex >= 0 && fieldsetIndex !== lengthOptionIndex) {
          excludeIndices.push(lengthOptionIndex);
        }
        this.fieldsets.forEach((_, index) => {
          if (index !== fieldsetIndex && !this.#optionExistsOnCurrentProduct(index) && !excludeIndices.includes(index)) {
            excludeIndices.push(index);
          }
        });
        const optionExistsOnProduct = this.#optionExistsOnCurrentProduct(fieldsetIndex);
        const distinctProductUrls = this.#fieldsetHasDistinctProductUrls(fieldset, fieldsetIndex);
        const isLengthFieldset = fieldsetIndex === lengthOptionIndex
          || Boolean(fieldset.closest("length-slider"));
        const preferredLength = isLengthFieldset ? this.#getUserPickedLength() : "";

        [...fieldset.elements].forEach((radio) => {
          if (radio.type !== 'radio') return;

          let isSelectable = false;
          let isAvailable = false;
          const optionLabel = radio.nextElementSibling?.tagName === 'LABEL'
            ? radio.nextElementSibling
            : null;

          if (useCombinedListings) {
            const optionUrl = this.#getOptionUrlForRadio(fieldset, fieldsetIndex, radio);
            const hasOptionUrl = !!optionUrl;
            const radioUrl = this.#normalizeProductUrl(optionUrl || "");
            const urlMatchesTarget = Boolean(
              distinctProductUrls && targetListingUrl && radioUrl && radioUrl === targetListingUrl
            );
            const testOptions = this.#buildAvailabilityTestOptions(selectedOptions, fieldsetIndex, radio.value, excludeIndices);
            const matchingListings = this.#getMatchingCombinedListings(testOptions, fieldsetIndex);

            isSelectable = matchingListings.length > 0 || urlMatchesTarget;
            if (!isSelectable && hasOptionUrl && fieldsetIndex === 0) {
              isSelectable = true;
            }
            isAvailable = matchingListings.some((entry) => entry.available === true) || urlMatchesTarget;
          } else {
            const testOptions = this.#buildAvailabilityTestOptions(selectedOptions, fieldsetIndex, radio.value, excludeIndices);
            const matchingVariants = this.#getMatchingVariants(testOptions, allVariants, fieldsetIndex);

            isSelectable = matchingVariants.length > 0;
            isAvailable = matchingVariants.some((variant) => variant.available === true);
          }

          radio.setAttribute("available", isAvailable ? "true" : "false");
          radio.disabled = !isSelectable;

          if (!isSelectable && radio.checked) {
            radio.checked = false;
            selectionChanged = true;
          }

          this.#applyAvailabilityStyles(radio, optionLabel, isAvailable, fieldsetIndex === lastNonLengthIndex);
        });

        const fieldsetRadios = [...fieldset.elements].filter((radio) => radio.type === 'radio');

        // Only hide option groups the current product does not own (Set on Schuko).
        // Never hide length: source-product radios (e.g. 7.5m) won't match the
        // target product until the section fetch swaps the slider HTML.
        if (!isLengthFieldset && !optionExistsOnProduct) {
          fieldset.hidden = true;
          fieldsetRadios.forEach((radio) => {
            if (radio.checked) {
              radio.checked = false;
              selectionChanged = true;
            }
          });
          return;
        }

        fieldset.hidden = false;

        const hasCheckedRadio = fieldsetRadios.some((radio) => radio.checked);
        const checkedRadio = fieldsetRadios.find((radio) => radio.checked) || null;
        const preferredLengthRadio = (
          isLengthFieldset
          && preferredLength
          && fieldsetRadios.find((radio) => (
            radio.value === preferredLength
            && !radio.disabled
            && radio.getAttribute("available") === "true"
          ))
        ) || null;
        const firstAvailableRadio = preferredLengthRadio
          || (isLengthFieldset
            ? (preferredLength
              ? this.#pickClosestAvailableLengthRadio(fieldsetRadios, preferredLength)
              : this.#pickSmallestAvailableLengthRadio(fieldsetRadios))
            : null)
          || fieldsetRadios.find((radio) => !radio.disabled && radio.getAttribute("available") === "true");

        if (
          checkedRadio
          && (checkedRadio.disabled || checkedRadio.getAttribute("available") !== "true")
          && firstAvailableRadio
          && firstAvailableRadio !== checkedRadio
        ) {
          checkedRadio.checked = false;
          firstAvailableRadio.checked = true;
          selectionChanged = true;
          return;
        }

        if (!hasCheckedRadio) {
          const autoSelectRadio = firstAvailableRadio
            || fieldsetRadios.find((radio) => !radio.disabled);
          if (autoSelectRadio) {
            autoSelectRadio.checked = true;
            selectionChanged = true;
          }
        }
      });

      if (selectionChanged) {
        this.updateOptions();
        this.updateVariantsAvailability(changedFieldsetIndex, pass + 1);
      }
    }

    /**
     * Get current variant from the single-variant JSON
     * This is the Horizon approach - server sends back the selected variant
     * @returns {Object|null} Current variant object
     */
    getCurrentVariant() {
      try {
        // Be explicit: this component also contains other JSON scripts (all variants, URLs, etc.)
        // so we must target the *current variant* only.
        const variantJsonElement = this.querySelector(".current-variant-json");
        if (!variantJsonElement) return null;

        const variant = JSON.parse(variantJsonElement.textContent);
        return variant || null;
      } catch (error) {
        console.error('Failed to parse current variant:', error);
        return null;
      }
    }

    /**
     * Get all variants from the all-variants JSON (for availability checking)
     * @returns {Array} Array of all variant objects
     * @private
     */
    #getAllVariants() {
      try {
        const variantJsonElement = this.querySelector(".variant-json");
        if (!variantJsonElement) return [];

        const variants = JSON.parse(variantJsonElement.textContent);
        return Array.isArray(variants) ? variants : [];
      } catch (error) {
        console.error('Failed to parse variants:', error);
        return [];
      }
    }

    /**
     * Resolve the fetched HTML source for a variant-dynamic target.
     * Sticky ATC and main product title/price use different markup, so each
     * target must sync from its own context instead of the first DOM match.
     * @param {Document} html - Parsed section HTML
     * @param {string} id - data-variant-dynamic id
     * @param {Element} target - Element to update on the live page
     * @returns {Element|null}
     * @private
     */
    #getVariantDynamicSource(html, id, target) {
      if (target.closest("sticky-atc")) {
        const selector = `sticky-atc [data-variant-dynamic="${id}"]`;
        const liveStickyTargets = Array.from(
          this.productParentElement.querySelectorAll(selector)
        );
        const sourceStickyTargets = Array.from(html.querySelectorAll(selector));
        const targetIndex = liveStickyTargets.indexOf(target);

        if (targetIndex >= 0 && sourceStickyTargets[targetIndex]) {
          return sourceStickyTargets[targetIndex];
        }

        return sourceStickyTargets[0] || null;
      }

      if (id === "product-title") {
        return html.querySelector('h1[data-variant-dynamic="product-title"]')
          || html.querySelector(`[data-variant-dynamic="${id}"]`);
      }

      if (id === "product-rating") {
        const sources = Array.from(html.querySelectorAll(`[data-variant-dynamic="${id}"]`));
        return sources.find((el) => !el.closest("sticky-atc")) || sources[0] || null;
      }

      return html.querySelector(`[data-variant-dynamic="${id}"]`);
    }

    /**
     * Fetch and render updated product info based on current selections
     * Uses data-variant-dynamic to update specific sections
     */
    renderProductInfo(hasLocalVariant = false) {
      try {
        const sectionId = this.dataset.section;

        // Build fetch URL using option_values (Horizon's approach)
        const baseUrl = this.currentProductUrl || this.explicitProductUrl || this.dataset.url;
        const normalizedBaseUrl = this.#normalizeProductUrl(baseUrl);
        const normalizedDatasetUrl = this.#normalizeProductUrl(this.dataset.url);

        // Only update the parts we actually want to change on variant switch.
        // For combined listing cross-product navigation, also update the media slider
        // and product title so the UI matches the product URL.
        // For same-product variant changes, keep slider intact to avoid resets/layout shifts.
        const isCrossProductNavigation = normalizedBaseUrl !== "" && normalizedBaseUrl !== normalizedDatasetUrl;
        const selectedOptionValueIds = [];
        this.fieldsets.forEach((fieldset) => {
          if (fieldset.hidden) return;
          const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
          if (checkedRadio && !checkedRadio.disabled && checkedRadio.dataset.optionValueId) {
            selectedOptionValueIds.push(checkedRadio.dataset.optionValueId);
          }
        });

        const preferredVariantId = this.#getPreferredVariantIdForFetch();
        let fetchUrl = `${baseUrl}?section_id=${sectionId}`;
        if (preferredVariantId) {
          fetchUrl = `${baseUrl}?variant=${preferredVariantId}&section_id=${sectionId}`;
        } else if (isCrossProductNavigation) {
          fetchUrl = `${baseUrl}?section_id=${sectionId}`;
        } else {
          if (selectedOptionValueIds.length === 0) return;
          fetchUrl = `${baseUrl}?option_values=${selectedOptionValueIds.join(',')}&section_id=${sectionId}`;
        }

        // Promoted accessories + PDP rating only swap on cross-product navigation.
        // Length-only changes must not reload that content (VOL-63 / Frank).
        // VOL-72: same-product variant changes must also refresh the gallery so the
        // selected variant's featured media is first (see product--main liquid order).
        const DYNAMIC_IDS_TO_UPDATE = isCrossProductNavigation
          ? ["variant-price", "variant-price-sticky", "product-slider-main", "product-title", "variant-options-sticky-mobile", "variant-radios", "product-promoted-accessories", "product-rating", "product-breadcrumbs"]
          : ["variant-price", "variant-price-sticky", "product-slider-main", "product-title", "variant-options-sticky-mobile", "product-breadcrumbs"];
        const elementsToUpdate = DYNAMIC_IDS_TO_UPDATE
          .flatMap((id) => Array.from(
            this.productParentElement.querySelectorAll(`[data-variant-dynamic="${id}"]`)
          ))
          .filter(Boolean);

        if (elementsToUpdate.length === 0) return;
        elementsToUpdate.forEach((item) => item.classList.add("opacity-20"));

        // Abort any previous in-flight fetch so stale responses never overwrite newer selections.
        if (this._renderFetchController) {
          this._renderFetchController.abort();
        }
        this._renderFetchController = new AbortController();
        const { signal } = this._renderFetchController;

        fetch(fetchUrl, { signal })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            const sourceProductParent = html.querySelector("[data-section][data-product]");
            if (sourceProductParent?.dataset.product) {
              this.productParentElement.dataset.product = sourceProductParent.dataset.product;
            }

            // Update only whitelisted dynamic blocks (e.g. price).
            DYNAMIC_IDS_TO_UPDATE.forEach((id) => {
              const targets = this.productParentElement.querySelectorAll(
                `[data-variant-dynamic="${id}"]`
              );
              if (!targets.length) return;

              targets.forEach((target) => {
                const source = this.#getVariantDynamicSource(html, id, target);
                if (!source) return;

                if (target.closest("sticky-atc") && (id === "product-title" || id === "variant-price-sticky" || id === "variant-options-sticky-mobile")) {
                  target.textContent = source.textContent.trim();
                  return;
                }

                Array.from(target.attributes).forEach((attribute) => {
                  if (attribute.name === "data-variant-dynamic") return;
                  if (!source.hasAttribute(attribute.name)) {
                    target.removeAttribute(attribute.name);
                  }
                });
                Array.from(source.attributes).forEach((attribute) => {
                  if (attribute.name === "data-variant-dynamic") return;
                  target.setAttribute(attribute.name, attribute.value);
                });
                target.innerHTML = source.innerHTML;

                if (id === "product-promoted-accessories") {
                  target.querySelectorAll("electric-slider").forEach((slider) => {
                    if (typeof slider.initSlider === "function") {
                      slider.initSlider();
                    }
                  });
                }

                if (id === "product-slider-main") {
                  const sliderEl = target.matches?.("electric-slider")
                    ? target
                    : target.querySelector("electric-slider");
                  const settleGallery = () => {
                    if (typeof sliderEl.reinitialize === "function") {
                      sliderEl.reinitialize();
                    } else if (typeof sliderEl.initSlider === "function") {
                      sliderEl.initSlider();
                    }
                    // product--main renders selected featured media first — land on slide 0.
                    if (typeof sliderEl.navigateSlider === "function") {
                      sliderEl.navigateSlider(0, "instant");
                    }
                  };
                  if (sliderEl) {
                    requestAnimationFrame(settleGallery);
                  }
                }
              });
            });

            if (isCrossProductNavigation) {
              this.#refreshStateAfterProductSwap(baseUrl, hasLocalVariant);
              this.#syncAtcForProductContext(html);
            } else {
              this.#restorePreferredLengthAndPrice();
            }

            // Remove loading state
            elementsToUpdate.forEach((item) => item.classList.remove("opacity-20"));
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            console.error('Failed to fetch product info:', error);
            elementsToUpdate.forEach((item) => item.classList.remove("opacity-20"));
          });
      } catch (error) {
        console.error('Error in renderProductInfo:', error);
      }
    }

    /**
     * Swap main/sticky ATC to Pre-order when the target combined-listing
     * product has `custom.presales`. Keeps the live `form` attribute intact.
     * @param {Document} html - Fetched section document
     * @private
     */
    #syncAtcForProductContext(html) {
      const sourceAtc = html.querySelector('[data-variant-dynamic="product-atc"]');
      const liveAtc = this.productParentElement?.querySelector('[data-variant-dynamic="product-atc"]');
      if (!sourceAtc || !liveAtc) {
        return;
      }

      const sourceButton = sourceAtc.querySelector('button[type="submit"]');
      const liveButton = liveAtc.querySelector('button[type="submit"]');
      const isPresales = sourceAtc.dataset.presales === "true"
        || Boolean(sourceButton?.classList.contains("button--presales"));

      liveAtc.dataset.presales = isPresales ? "true" : "false";

      if (liveButton && sourceButton) {
        const formAttr = liveButton.getAttribute("form");
        liveButton.className = sourceButton.className;
        if (formAttr) {
          liveButton.setAttribute("form", formAttr);
        } else {
          liveButton.removeAttribute("form");
        }

        const sourceLabel = sourceButton.querySelector(".default-context");
        if (typeof liveAtc.setCtaLabel === "function") {
          liveAtc.setCtaLabel(sourceLabel?.innerHTML || sourceLabel?.textContent || "");
        }
      }

      const sourceCutoff = sourceAtc.querySelector("[data-cutoff-dispatch]");
      const liveCutoff = liveAtc.querySelector("[data-cutoff-dispatch]");
      if (sourceCutoff && liveCutoff) {
        liveCutoff.replaceWith(sourceCutoff.cloneNode(true));
      } else if (sourceCutoff && !liveCutoff) {
        liveAtc.appendChild(sourceCutoff.cloneNode(true));
      } else if (!sourceCutoff && liveCutoff) {
        liveCutoff.remove();
      }

      const productForm = liveAtc.closest("product-form");
      if (productForm && typeof productForm.updateCutoffDispatchMessage === "function") {
        productForm.updateCutoffDispatchMessage();
      }

      const preOrderLabel = window.variantStrings?.preOrder || "";
      const addToCartLabel = window.variantStrings?.addToCart || "";
      this.productParentElement.querySelectorAll("sticky-atc product-buttons").forEach((stickyButtons) => {
        stickyButtons.dataset.presales = isPresales ? "true" : "false";
        const stickyButton = stickyButtons.querySelector('button[type="submit"]');
        if (!stickyButton) {
          return;
        }
        stickyButton.classList.toggle("button--presales", isPresales);
        stickyButton.classList.toggle("bg-blue-700", !isPresales);
        if (isPresales && preOrderLabel) {
          stickyButton.setAttribute("aria-label", preOrderLabel);
        } else if (addToCartLabel) {
          stickyButton.setAttribute("aria-label", addToCartLabel);
        }
      });

      this.updateButtonAvailability();
    }

    /**
     * Update product-buttons availability based on current variant
     */
    updateButtonAvailability() {
      // Prefer option-matched variant; fall back to server JSON for single-/default-variant PDPs.
      const currentVariant = this.#getSelectedVariantFromOptions() || this.getCurrentVariant();
      const availabilityState = this.#getAvailabilityState(currentVariant);
      const isAvailable = availabilityState === "available";
      const availableString = isAvailable ? "true" : "false";

      this.productButtons = this.productParentElement.querySelectorAll("product-buttons");
      this.productButtons.forEach((button) => {
        button.setAttribute("availability", availabilityState);
        button.setAttribute("available", availableString);

        // Force update if method exists
        if (button.updateButtonState && typeof button.updateButtonState === 'function') {
          button.updateButtonState();
        }
      });

      // Re-apply on next frame so UI never stays stale after nested radio/slider updates.
      requestAnimationFrame(() => {
        this.productButtons.forEach((button) => {
          button.setAttribute("availability", availabilityState);
          button.setAttribute("available", availableString);
          if (button.updateButtonState && typeof button.updateButtonState === 'function') {
            button.updateButtonState();
          }
        });
      });

      this.qtyInput?.setAttribute("available", availableString);
    }

    /**
     * Public accessor for the currently selected variant based on checked options.
     * Returns null when the current checked combination does not resolve to a variant.
     * @returns {Object|null}
     */
    getSelectedVariant() {
      return this.#getSelectedVariantFromOptions();
    }

    updateURL() {
      // Check if URL updates are disabled
      if (this.dataset.updateUrl === "false") return;

      // If we have a currentProductUrl from combined listings, always use it —
      // even when the selected variant is not resolvable in the local JSON yet.
      if (this.currentProductUrl) {
        try {
          const url = new URL(this.currentProductUrl, window.location.origin);
          if (this.currentTargetVariantId) {
            url.searchParams.set('variant', this.currentTargetVariantId);
          }
          window.history.replaceState({}, "", url.toString());
        } catch (error) {}
        return;
      }

      const currentVariant = this.#getSelectedVariantFromOptions() || this.getCurrentVariant();
      if (!currentVariant) return;

      // Regular variant URL update
      if (!this.quickAtcMode || !window.location.pathname.includes("/products/")) {
        return;
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        window.history.replaceState({}, "", url.toString());
      } catch (error) {}
    }

    updateVariantInput() {
      const currentVariant = this.#getSelectedVariantFromOptions() || this.getCurrentVariant();
      if (!currentVariant) return;
      this.#updateVariantInputWithId(currentVariant.id);
    }

    /**
     * Find the selected variant by matching current option values against `variant-json`.
     * @returns {Object|null} Variant object
     * @private
     */
    #getSelectedVariantFromOptions() {
      try {
        // Ensure we have latest option selections.
        if (!this.options) this.updateOptions();
        if (!this.options || this.options.length === 0) return null;
        if (!this.#hasCompleteSelection()) return null;

        const allVariants = this.#getAllVariants();
        if (!allVariants || allVariants.length === 0) return null;

        const combinedListingMatch = this.#getExactCombinedListingMatch(this.options);
        if (combinedListingMatch?.variantId) {
          const matchedVariant = this.#findVariantById(combinedListingMatch.variantId, allVariants);
          if (matchedVariant) {
            return matchedVariant;
          }
        }

        const matchingVariants = this.#getMatchingVariants(this.options, allVariants);
        if (!matchingVariants.length) {
          return null;
        }

        const targetVariantId = this.currentTargetVariantId ? String(this.currentTargetVariantId) : "";
        return matchingVariants.find((variant) => targetVariantId && String(variant?.id) === targetVariantId)
          || matchingVariants.find((variant) => variant?.available === true)
          || matchingVariants[0]
          || null;
      } catch (error) {
        return null;
      }
    }

    /**
     * Resolve the add-to-cart availability state for the current selection.
     * @param {Object|null} currentVariant - Currently matched variant
     * @returns {string} One of "available", "sold-out", or "unavailable"
     * @private
     */
    #getAvailabilityState(currentVariant) {
      // No option UI (single/default variant) — trust the server-rendered variant.
      if (!Array.isArray(this.fieldsets) || this.fieldsets.length === 0) {
        const variant = currentVariant || this.getCurrentVariant();
        if (!variant) {
          return "unavailable";
        }
        return variant.available === true ? "available" : "sold-out";
      }

      if (!this.#hasCompleteSelection() || this.#hasDisabledCheckedOption()) {
        return "unavailable";
      }

      const combinedListingMatch = this.#getExactCombinedListingMatch();
      if (combinedListingMatch) {
        return combinedListingMatch.available === true ? "available" : "sold-out";
      }

      if (this.#hasUnavailableCheckedOption()) {
        return currentVariant?.available === false ? "sold-out" : "unavailable";
      }

      if (!currentVariant) {
        return "unavailable";
      }

      if (currentVariant.available !== true) {
        return "sold-out";
      }

      return "available";
    }

    /**
     * Check whether all option groups currently have a selected value.
     * @returns {boolean} True when every fieldset has a selection
     * @private
     */
    #hasCompleteSelection() {
      if (!this.options) {
        this.updateOptions();
      }

      // Nothing to pick — single-/default-variant products are always "complete".
      if (!Array.isArray(this.fieldsets) || this.fieldsets.length === 0) {
        return true;
      }

      return this.fieldsets.every((fieldset, index) => {
        if (fieldset.hidden) {
          return true;
        }

        const radios = [...fieldset.elements].filter((radio) => radio.type === "radio");
        if (radios.length === 0) {
          return true;
        }

        const hasSelectable = radios.some((radio) => !radio.disabled);
        if (!hasSelectable) {
          return true;
        }

        const value = this.options[index];
        return typeof value === "string" && value.trim() !== "";
      });
    }

    /**
     * Check if the current checked selection includes an option that cannot be selected.
     * @returns {boolean} True when any checked radio is disabled
     * @private
     */
    #hasDisabledCheckedOption() {
      const checkedRadios = this.querySelectorAll('input[type="radio"]:checked');

      for (const radio of checkedRadios) {
        if (radio.closest("fieldset")?.hidden) {
          continue;
        }
        if (radio.disabled) {
          return true;
        }
      }

      return false;
    }

    /**
     * Check if the current checked selection includes an option marked unavailable.
     * @returns {boolean} True when any checked radio is marked unavailable
     * @private
     */
    #hasUnavailableCheckedOption() {
      const checkedRadios = this.querySelectorAll('input[type="radio"]:checked');

      for (const radio of checkedRadios) {
        if (radio.closest("fieldset")?.hidden) {
          continue;
        }
        if (radio.getAttribute("available") === "false") {
          return true;
        }
      }

      return false;
    }

    /**
     * Refresh cached references and rerun availability logic after swapping to another product context.
     * @private
     */
    #refreshStateAfterProductSwap(baseUrl, hasLocalVariant = false) {
      this.fieldsets = [...this.querySelectorAll("fieldset")];
      this.qtyInput = this.productParentElement.querySelector("quantity-input");
      this.productButtons = this.productParentElement.querySelectorAll("product-buttons");
      this.productForms = this.productParentElement.querySelectorAll("product-form");
      this.outputs = this.productParentElement.querySelectorAll("._selectedOption");
      this.quantitySelector = this.productParentElement.querySelector("quantity-input");

      this.#loadOptionData();
      this.#sortPowerOptionContainers();
      if (typeof baseUrl === "string" && baseUrl.trim() !== "") {
        this.dataset.url = baseUrl;
      }
      this.currentProductUrl = null;
      this.currentTargetVariantId = null;
      this.updateOptions();
      this.updateVariantsAvailability();
      this.#refreshLengthSliderState();
      this.updateOutputs();
      this.#restorePreferredLengthAndPrice();
    }

    /**
     * Update variant input fields with a specific variant ID
     * @param {number|string} variantId - The variant ID to set
     * @private
     */
    #updateVariantInputWithId(variantId) {
      if (!variantId) return;

      try {
        // Update forms in product-form components
        const productForms = this.productParentElement?.querySelectorAll('product-form') || [];
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (input) {
            input.value = variantId;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });

        // Also update forms in product-card-atc components (skip accessory upsells —
        // they keep their own variant ids and live under product-promoted-accessories).
        const productCardAtcs = this.productParentElement?.querySelectorAll('product-card-atc') || [];
        productCardAtcs.forEach((atcComponent) => {
          if (atcComponent.closest('[data-variant-dynamic="product-promoted-accessories"]')) {
            return;
          }
          const form = atcComponent.querySelector('form[data-type="add-to-cart-form"]');
          if (form) {
            const input = form.querySelector('input[name="id"]');
            if (input) {
              input.value = variantId;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        });

        // Update quantity selector
        const quantitySelector = this.productParentElement?.querySelector("quantity-input");
        if (quantitySelector) {
          quantitySelector.dataset.id = variantId;
        }
      } catch (error) {
        console.error('Failed to update variant input:', error);
      }
    }
  }

  customElements.define("variant-radios", VariantRadios);
}
})();
(function () {
/**
 * ProductVariantPreview Web Component
 * 
 * Handles hover-triggered fetching of product variant pages and replaces
 * variant-dynamic content without navigation. Provides smooth UX for
 * variant exploration.
 * 
 * @example
 * <a href="/products/product-handle?variant=123" 
 *    data-variant-preview 
 *    data-section-id="product--main">
 *   Variant Option
 * </a>
 */
class ProductVariantPreview extends HTMLElement {
  /** @type {AbortController | null} Current fetch abort controller */
  #abortController = null;
  
  /** @type {number | null} Hover delay timer */
  #hoverTimer = null;
  
  /** @type {boolean} Component connection state */
  #isConnected = false;
  
  /** @type {number} Hover delay before fetch starts (ms) */
  #hoverDelay = 300;
  
  /** @type {boolean} Whether fetch is in progress */
  #isFetching = false;
  
  /** @type {string | null} Currently loaded variant URL */
  #currentVariantUrl = null;

  constructor() {
    super();
  }

  /**
   * Get the href attribute value
   * @returns {string} The href attribute value
   */
  get href() {
    return this.getAttribute('href') || '';
  }

  /**
   * Set the href attribute value
   * @param {string} value - The href value to set
   */
  set href(value) {
    this.setAttribute('href', value);
  }

  connectedCallback() {
    console.log('🔍 ProductVariantPreview: connectedCallback triggered');
    console.log('🔍 ProductVariantPreview: Is connected:', this.#isConnected);
    
    if (this.#isConnected) {
      console.log('🔍 ProductVariantPreview: Already connected, skipping initialization');
      return;
    }
    
    try {
      this.#isConnected = true;
      console.log('🔍 ProductVariantPreview: Set isConnected to true');
      this.#initializeEventListeners();
    } catch (error) {
      console.error('🔍 ProductVariantPreview: Error in connectedCallback:', error);
      this.#handleError('Failed to initialize variant preview', error);
    }
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  /**
   * Initialize event listeners for hover interactions
   * @private
   */
  #initializeEventListeners() {
    console.log('🔍 ProductVariantPreview: Initializing event listeners');
    console.log('🔍 ProductVariantPreview: Element href:', this.href);
    console.log('🔍 ProductVariantPreview: Element href attribute:', this.getAttribute('href'));
    console.log('🔍 ProductVariantPreview: Element dataset:', this.dataset);
    
    // Prevent default navigation on click
    this.addEventListener('click', this.#handleClick.bind(this));
    
    // Handle hover start
    this.addEventListener('mouseenter', this.#handleMouseEnter.bind(this));
    this.addEventListener('focus', this.#handleMouseEnter.bind(this));
    
    // Handle hover end
    this.addEventListener('mouseleave', this.#handleMouseLeave.bind(this));
    this.addEventListener('blur', this.#handleMouseLeave.bind(this));
    
    console.log('🔍 ProductVariantPreview: Event listeners initialized');
  }

  /**
   * Handle click events - prevent default navigation
   * @param {Event} event - Click event
   * @private
   */
  #handleClick(event) {
    console.log('🔍 ProductVariantPreview: Click event triggered');
    console.log('🔍 ProductVariantPreview: Current variant URL:', this.#currentVariantUrl);
    console.log('🔍 ProductVariantPreview: Element href:', this.href);
    console.log('🔍 ProductVariantPreview: Is fetching:', this.#isFetching);
    
    // Only prevent default if we have successfully loaded a variant
    if (this.#currentVariantUrl) {
      console.log('🔍 ProductVariantPreview: Preventing default navigation');
      event.preventDefault();
      
      // Dispatch custom event for parent components to handle
      this.dispatchEvent(new CustomEvent('variant:preview-click', {
        detail: { 
          variantUrl: this.href,
          currentVariantUrl: this.#currentVariantUrl 
        },
        bubbles: true
      }));
      
      console.log('🔍 ProductVariantPreview: Dispatched variant:preview-click event');
    } else {
      console.log('🔍 ProductVariantPreview: No current variant URL, allowing default navigation');
    }
  }

  /**
   * Handle mouse enter/focus events - start hover timer
   * @param {Event} event - Mouse enter or focus event
   * @private
   */
  #handleMouseEnter(event) {
    console.log('🔍 ProductVariantPreview: Mouse enter/focus event');
    console.log('🔍 ProductVariantPreview: Element href:', this.href);
    
    // Clear any existing timer
    clearTimeout(this.#hoverTimer);
    
    // Start new timer
    this.#hoverTimer = setTimeout(() => {
      console.log('🔍 ProductVariantPreview: Hover timer expired, starting fetch');
      this.#fetchVariantContent();
    }, this.#hoverDelay);
    
    console.log('🔍 ProductVariantPreview: Started hover timer for', this.#hoverDelay, 'ms');
  }

  /**
   * Handle mouse leave/blur events - cancel operations
   * @param {Event} event - Mouse leave or blur event
   * @private
   */
  #handleMouseLeave(event) {
    console.log('🔍 ProductVariantPreview: Mouse leave/blur event');
    
    // Clear hover timer
    clearTimeout(this.#hoverTimer);
    this.#hoverTimer = null;
    
    // Abort any ongoing fetch
    if (this.#abortController) {
      console.log('🔍 ProductVariantPreview: Aborting ongoing fetch');
      this.#abortController.abort();
      this.#abortController = null;
    }
    
    console.log('🔍 ProductVariantPreview: Cleared hover timer and aborted fetch');
  }

  /**
   * Get list of sections that need to be fetched based on variant-dynamic elements
   * @returns {string[]} Array of section IDs to fetch
   * @private
   */
  #getSectionsToFetch() {
    const sections = new Set();
    
    // Find all variant-dynamic elements and determine their sections
    document.querySelectorAll('[data-variant-dynamic]').forEach(element => {
      const sectionId = element.dataset.sectionId || this.#getSectionIdFromElement(element);
      if (sectionId) {
        sections.add(sectionId);
      }
    });
    
    // Always include the main product section
    sections.add('product--main');
    
    return Array.from(sections);
  }

  /**
   * Get section ID from element by traversing up the DOM
   * @param {Element} element - The element to find section for
   * @returns {string|null} Section ID or null if not found
   * @private
   */
  #getSectionIdFromElement(element) {
    // Look for section element with id attribute
    const section = element.closest('section[id]');
    if (section) {
      return section.id;
    }
    
    // Look for section element with data-section-id
    const sectionWithData = element.closest('section[data-section-id]');
    if (sectionWithData) {
      return sectionWithData.dataset.sectionId;
    }
    
    return null;
  }

  /**
   * Fetch a specific section using Shopify's section rendering API
   * @param {string} sectionId - The section ID to fetch
   * @returns {Promise<{sectionId: string, html: string}>} Section data
   * @private
   */
  async #fetchSection(sectionId) {
    console.log('🔍 ProductVariantPreview: Fetching section:', sectionId);
    
    const fetchUrl = `${this.href}?section_id=${sectionId}`;
    console.log('🔍 ProductVariantPreview: Section fetch URL:', fetchUrl);
    
    const response = await fetch(fetchUrl, {
      signal: this.#abortController.signal,
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Failed to fetch section ${sectionId}: HTTP ${response.status}`);
    }
    
    const html = await response.text();
    console.log('🔍 ProductVariantPreview: Fetched section', sectionId, 'length:', html.length);
    
    return { sectionId, html };
  }

  /**
   * Fetch variant content from the product page
   * @private
   */
  async #fetchVariantContent() {
    console.log('🔍 ProductVariantPreview: Starting fetchVariantContent');
    console.log('🔍 ProductVariantPreview: Is fetching:', this.#isFetching);
    console.log('🔍 ProductVariantPreview: Element href:', this.href);
    
    if (this.#isFetching || !this.href) {
      console.log('🔍 ProductVariantPreview: Fetch blocked - isFetching:', this.#isFetching, 'href:', this.href);
      return;
    }
    
    try {
      this.#isFetching = true;
      console.log('🔍 ProductVariantPreview: Set isFetching to true');
      
      // Add loading state
      this.setAttribute('data-loading', 'true');
      console.log('🔍 ProductVariantPreview: Added data-loading attribute');
      
      // Create new abort controller for this fetch
      this.#abortController = new AbortController();
      
      // Get all sections that need to be fetched
      const sectionsToFetch = this.#getSectionsToFetch();
      console.log('🔍 ProductVariantPreview: Sections to fetch:', sectionsToFetch);
      
      // Fetch all sections in parallel
      const fetchPromises = sectionsToFetch.map(sectionId => 
        this.#fetchSection(sectionId)
      );
      
      const sectionResults = await Promise.all(fetchPromises);
      console.log('🔍 ProductVariantPreview: All sections fetched successfully');
      
      // Update variant-dynamic content with all fetched sections
      await this.#updateVariantContent(sectionResults, this.href);
      
      // Store current variant URL
      this.#currentVariantUrl = this.href;
      console.log('🔍 ProductVariantPreview: Stored current variant URL:', this.#currentVariantUrl);
      
      // Dispatch success event
      this.dispatchEvent(new CustomEvent('variant:preview-loaded', {
        detail: { variantUrl: this.href, sectionsFetched: sectionsToFetch },
        bubbles: true
      }));
      
      console.log('🔍 ProductVariantPreview: Dispatched variant:preview-loaded event');
      
    } catch (error) {
      // Don't throw for aborted requests
      if (error.name === 'AbortError') {
        console.log('🔍 ProductVariantPreview: Fetch was aborted');
        return;
      }
      
      console.error('🔍 ProductVariantPreview: Fetch error:', error);
      this.#handleError('Failed to fetch variant content', error);
    } finally {
      this.#isFetching = false;
      this.#abortController = null;
      
      // Remove loading state
      this.removeAttribute('data-loading');
      console.log('🔍 ProductVariantPreview: Cleanup completed - isFetching:', this.#isFetching);
    }
  }

  /**
   * Update variant-dynamic content with fetched sections
   * @param {Array<{sectionId: string, html: string}>} sectionResults - Array of fetched sections
   * @param {string} variantUrl - Variant URL being loaded
   * @private
   */
  async #updateVariantContent(sectionResults, variantUrl) {
    console.log('🔍 ProductVariantPreview: Starting updateVariantContent');
    console.log('🔍 ProductVariantPreview: Variant URL:', variantUrl);
    console.log('🔍 ProductVariantPreview: Sections to process:', sectionResults.length);
    
    try {
      // Parse all fetched sections
      const sectionDocs = new Map();
      sectionResults.forEach(({ sectionId, html }) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        sectionDocs.set(sectionId, doc);
        console.log('🔍 ProductVariantPreview: Parsed section:', sectionId);
      });
      
      // Find all variant-dynamic elements in the current page
      const currentElements = document.querySelectorAll('[data-variant-dynamic]');
      console.log('🔍 ProductVariantPreview: Found variant-dynamic elements:', currentElements.length);
      
      if (currentElements.length === 0) {
        console.warn('ProductVariantPreview: No variant-dynamic elements found on current page');
        return;
      }
      
      // Add loading state
      currentElements.forEach(element => {
        element.classList.add('opacity-20', 'transition-opacity', 'duration-200');
      });
      console.log('🔍 ProductVariantPreview: Added loading state to elements');
      
      // Update each variant-dynamic element
      let updatedCount = 0;
      currentElements.forEach(element => {
        const dynamicId = element.dataset.variantDynamic;
        if (!dynamicId) {
          console.log('🔍 ProductVariantPreview: Element missing variantDynamic ID:', element);
          return;
        }
        
        console.log('🔍 ProductVariantPreview: Processing element with ID:', dynamicId);
        
        // Determine which section this element belongs to
        const elementSectionId = element.dataset.sectionId || this.#getSectionIdFromElement(element) || 'product--main';
        console.log('🔍 ProductVariantPreview: Element section ID:', elementSectionId);
        
        // Get the corresponding section document
        const sectionDoc = sectionDocs.get(elementSectionId);
        if (!sectionDoc) {
          console.log('🔍 ProductVariantPreview: No section document found for:', elementSectionId);
          return;
        }
        
        // Find corresponding element in fetched content
        const fetchedElement = sectionDoc.querySelector(`[data-variant-dynamic="${dynamicId}"]`);
        
        if (fetchedElement) {
          console.log('🔍 ProductVariantPreview: Found matching element in fetched content');
          
          // Handle keep/remove attributes
          let updatedContent = fetchedElement.innerHTML;
          
          if (element.dataset.keep) {
            console.log('🔍 ProductVariantPreview: Applying keep attributes:', element.dataset.keep);
            updatedContent = this.#applyKeepAttributes(updatedContent, element.dataset.keep);
          }
          
          if (element.dataset.remove) {
            console.log('🔍 ProductVariantPreview: Applying remove attributes:', element.dataset.remove);
            updatedContent = this.#applyRemoveAttributes(updatedContent, element.dataset.remove);
          }
          
          // Update the content
          element.innerHTML = updatedContent;
          updatedCount++;
          console.log('🔍 ProductVariantPreview: Updated element:', dynamicId);
        } else {
          console.log('🔍 ProductVariantPreview: No matching element found for ID:', dynamicId, 'in section:', elementSectionId);
        }
      });
      
      // Remove loading state
      currentElements.forEach(element => {
        element.classList.remove('opacity-20');
      });
      console.log('🔍 ProductVariantPreview: Removed loading state from elements');
      
      // Dispatch content updated event
      this.dispatchEvent(new CustomEvent('variant:content-updated', {
        detail: { variantUrl, updatedElements: updatedCount, sectionsProcessed: sectionResults.length },
        bubbles: true
      }));
      
      console.log('🔍 ProductVariantPreview: Dispatched content-updated event, updated elements:', updatedCount);
      
    } catch (error) {
      console.error('🔍 ProductVariantPreview: Error in updateVariantContent:', error);
      this.#handleError('Failed to update variant content', error);
    }
  }

  /**
   * Apply keep attributes to preserve specific form elements
   * @param {string} content - HTML content to modify
   * @param {string} keepData - JSON string of attributes to keep
   * @returns {string} Modified content
   * @private
   */
  #applyKeepAttributes(content, keepData) {
    try {
      const keepAttributes = JSON.parse(keepData);
      
      Object.entries(keepAttributes).forEach(([attribute, value]) => {
        if (attribute === 'form') {
          // Preserve form attribute by finding form elements and keeping their form attribute
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = content;
          
          tempDiv.querySelectorAll('input, select, textarea, button').forEach(element => {
            if (element.form) {
              element.setAttribute('form', element.form.id || element.form.name);
            }
          });
          
          content = tempDiv.innerHTML;
        }
      });
      
      return content;
    } catch (error) {
      console.warn('ProductVariantPreview: Failed to parse keep attributes', error);
      return content;
    }
  }

  /**
   * Apply remove attributes to strip specific attributes
   * @param {string} content - HTML content to modify
   * @param {string} removeData - Comma-separated list of attributes to remove
   * @returns {string} Modified content
   * @private
   */
  #applyRemoveAttributes(content, removeData) {
    try {
      const removeAttributes = removeData.split(',').map(attr => attr.trim());
      
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = content;
      
      tempDiv.querySelectorAll('*').forEach(element => {
        removeAttributes.forEach(attr => {
          element.removeAttribute(attr);
        });
      });
      
      return tempDiv.innerHTML;
    } catch (error) {
      console.warn('ProductVariantPreview: Failed to apply remove attributes', error);
      return content;
    }
  }

  /**
   * Handle errors gracefully with user feedback
   * @param {string} message - Error message
   * @param {Error} error - Original error object
   * @private
   */
  #handleError(message, error) {
    console.error(`ProductVariantPreview: ${message}`, error);
    
    this.dispatchEvent(new CustomEvent('variant:preview-error', {
      detail: { 
        message, 
        error: error.message,
        variantUrl: this.href 
      },
      bubbles: true
    }));
  }

  /**
   * Clean up resources and event listeners
   * @private
   */
  #cleanup() {
    this.#isConnected = false;
    
    // Clear timers
    clearTimeout(this.#hoverTimer);
    this.#hoverTimer = null;
    
    // Abort any ongoing fetch
    if (this.#abortController) {
      this.#abortController.abort();
      this.#abortController = null;
    }
    
    this.#isFetching = false;
    this.#currentVariantUrl = null;
  }
}

// Register the web component
console.log('🔍 ProductVariantPreview: Registering web component');
customElements.define('product-variant-preview', ProductVariantPreview);
console.log('🔍 ProductVariantPreview: Web component registered successfully');

// Link conversion is now handled by electric-variant-link-converter component
// This ensures it works even when scripts are injected after DOM is ready
})();
(function () {
/**
 * <variant-dynamic-section> — Self-updating section wrapper for variant changes.
 *
 * Listens for the `voldt:variant:changed` event (dispatched by variant-radios) and
 * re-fetches its own Shopify section via the Section Rendering API. After fetching
 * it swaps every nested `[data-variant-dynamic]` element's innerHTML with the
 * corresponding content from the fetched HTML — keeping markup around them intact.
 *
 * Required attributes:
 *   - data-section-id  Shopify section id (e.g. "{{ section.id }}").
 *
 * Optional attributes:
 *   - data-product-url Canonical product URL. Falls back to the event's productUrl.
 *
 * @example
 *   <variant-dynamic-section
 *     data-section-id="{{ section.id }}"
 *     data-product-url="{{ product.url }}">
 *     <div data-variant-dynamic="sockets">…</div>
 *   </variant-dynamic-section>
 */
if (!customElements.get("variant-dynamic-section")) {
  class VariantDynamicSection extends HTMLElement {
    #fetchController = null;
    #listenerController = null;
    #isFetching = false;

    connectedCallback() {
      this.#listenerController = new AbortController();
      document.addEventListener(
        "voldt:variant:changed",
        (event) => this.#handleVariantChanged(event),
        { signal: this.#listenerController.signal }
      );
    }

    disconnectedCallback() {
      if (this.#listenerController) {
        this.#listenerController.abort();
        this.#listenerController = null;
      }
      if (this.#fetchController) {
        this.#fetchController.abort();
        this.#fetchController = null;
      }
    }

    /**
     * Handle variant change events from the product form.
     * @param {CustomEvent} event - Event dispatched by variant-radios
     * @private
     */
    async #handleVariantChanged(event) {
      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;

      const detail = event?.detail || {};
      const productUrl = (detail.productUrl || this.dataset.productUrl || "").trim();
      if (!productUrl) return;

      // Optional: only refetch when the active product changes (combined listings).
      // Same-product option changes (e.g. cable length) are ignored.
      if (this.dataset.reloadOn === "product") {
        const nextProductId =
          detail.productId != null && detail.productId !== ""
            ? String(detail.productId)
            : "";
        const currentProductId = this.dataset.productId ? String(this.dataset.productId) : "";

        if (!nextProductId) return;
        if (currentProductId && nextProductId === currentProductId) return;

        this.dataset.productId = nextProductId;
        this.dataset.productUrl = productUrl;
      }

      const optionValueIds = Array.isArray(detail.optionValueIds)
        ? detail.optionValueIds.filter(Boolean)
        : [];
      const variantId = detail.variantId ? String(detail.variantId) : "";

      const fetchUrl = this.#buildFetchUrl(productUrl, sectionId, optionValueIds, variantId);
      if (!fetchUrl) return;

      await this.#fetchAndSwap(fetchUrl);
    }

    /**
     * Compose the section rendering URL from the active variant selection.
     * Prefers option_values when present (matches product--main behaviour and
     * avoids resolving to the product's default variant on the target page).
     * @param {string} productUrl - Base product URL
     * @param {string} sectionId - Target section id
     * @param {Array<string>} optionValueIds - Selected option_value_ids
     * @param {string} variantId - Resolved variant id (fallback)
     * @returns {string} Fully qualified fetch URL
     * @private
     */
    #buildFetchUrl(productUrl, sectionId, optionValueIds, variantId) {
      try {
        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set("section_id", sectionId);

        if (optionValueIds.length > 0) {
          url.searchParams.set("option_values", optionValueIds.join(","));
        } else if (variantId) {
          url.searchParams.set("variant", variantId);
        } else {
          return "";
        }

        return url.toString();
      } catch (error) {
        return "";
      }
    }

    /**
     * Fetch the section HTML and swap every nested data-variant-dynamic element.
     * Cancels any in-flight request so late responses never overwrite newer ones.
     * @param {string} fetchUrl - Section Rendering API URL
     * @private
     */
    async #fetchAndSwap(fetchUrl) {
      if (this.#fetchController) {
        this.#fetchController.abort();
      }
      this.#fetchController = new AbortController();
      const { signal } = this.#fetchController;

      const targets = this.querySelectorAll("[data-variant-dynamic]");
      if (!targets.length) return;

      targets.forEach((target) => target.classList.add("opacity-20"));
      this.#isFetching = true;

      try {
        const response = await fetch(fetchUrl, {
          signal,
          headers: {
            Accept: "text/html",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (!response.ok) {
          throw new Error(`Section fetch failed: HTTP ${response.status}`);
        }

        const responseText = await response.text();
        const parsedHtml = new DOMParser().parseFromString(responseText, "text/html");

        let swappedCount = 0;
        targets.forEach((target) => {
          const dynamicId = target.dataset.variantDynamic;
          if (!dynamicId) return;

          const source = parsedHtml.querySelector(`[data-variant-dynamic="${dynamicId}"]`);
          if (!source) return;

          target.innerHTML = source.innerHTML;
          swappedCount += 1;
        });

        this.dispatchEvent(new CustomEvent("variant-dynamic-section:swapped", {
          detail: { sectionId: this.dataset.sectionId, swappedCount },
          bubbles: true,
        }));
      } catch (error) {
        if (error?.name === "AbortError") return;
        console.error("variant-dynamic-section: fetch failed", error);
      } finally {
        targets.forEach((target) => target.classList.remove("opacity-20"));
        this.#isFetching = false;
      }
    }
  }

  customElements.define("variant-dynamic-section", VariantDynamicSection);
}
})();
(function () {
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      #formWrapper;
      #stickyElement;
      #isVisible = false;
      #animation = null;
      #observer;
      #findMyCarObserver;
      #isAtBottom = false;
      #isFindMyCarInView = false;
      #shouldShowFromForm = false;
      #scrollHandler;
      #abortController = null;
      #radiosAbortController = null;
      #lengthMutationObserver = null;
      #isSyncingLength = false;
      #isLengthRefreshQueued = false;
      #resizeHandler;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#formWrapper = document.querySelector('product-buttons');
        this.#stickyElement = this.firstElementChild;
        if (!this.#stickyElement) return;
        this.#stickyElement.id = 'sticky-atc';
        this.#scrollHandler = () => this.#handleScroll();
        this.#setupObserver();
        this.#setupFindMyCarObserver();
        this.#setupLengthDropdownSync();
        window.addEventListener('scroll', this.#scrollHandler, { passive: true });
        this.#resizeHandler = () => this.#handleResize();
        window.addEventListener('resize', this.#resizeHandler);
        this.#syncGlobalStickyState();
      }

      /**
       * Lifecycle: When element is removed from DOM
       */
      disconnectedCallback() {
        this.#observer?.disconnect();
        this.#findMyCarObserver?.disconnect();
        this.#animation?.cancel();
        this.#abortController?.abort();
        this.#radiosAbortController?.abort();
        this.#lengthMutationObserver?.disconnect();
        window.removeEventListener('scroll', this.#scrollHandler);
        window.removeEventListener('resize', this.#resizeHandler);
      }

      /**
       * Two-way sync between sticky length dropdown and main form length radios.
       * Dropdown → radios: user picks a value in the dropdown, the matching radio is checked.
       * Radios → dropdown: main slider (or any other source) checks a radio, the dropdown follows.
       */
      #setupLengthDropdownSync() {
        const selects = Array.from(this.querySelectorAll('[data-length-dropdown]'));
        if (!selects.length) return;

        this.#abortController = new AbortController();
        const { signal } = this.#abortController;

        selects.forEach((select) => {
          select.addEventListener('change', (e) => this.#handleDropdownChange(e), { signal });
        });
        this.#bindLengthRadioListeners();
        this.#refreshAllLengthDropdowns();
        this.#observeLengthSourceChanges();
      }

      /**
       * Observe variant-radios subtree so sticky dropdown can refresh
       * when the length slider/radios are replaced after variant refetches.
       */
      #observeLengthSourceChanges() {
        const variantRadios = document.querySelector('variant-radios');
        if (!variantRadios) return;

        this.#lengthMutationObserver?.disconnect();
        this.#lengthMutationObserver = new MutationObserver((mutations) => {
          const hasChildListChanges = mutations.some((mutation) => mutation.type === 'childList');
          if (!hasChildListChanges) return;
          this.#queueLengthDropdownRefresh();
        });

        this.#lengthMutationObserver.observe(variantRadios, {
          childList: true,
          subtree: true
        });
      }

      /**
       * Queue a single dropdown refresh in the next frame.
       */
      #queueLengthDropdownRefresh() {
        if (this.#isLengthRefreshQueued) return;
        this.#isLengthRefreshQueued = true;

        requestAnimationFrame(() => {
          this.#isLengthRefreshQueued = false;
          this.#refreshAllLengthDropdowns();
        });
      }

      /**
       * Refresh all sticky length dropdown instances (mobile + desktop).
       */
      #refreshAllLengthDropdowns() {
        const selects = this.querySelectorAll('[data-length-dropdown]');
        selects.forEach((select) => this.#refreshLengthDropdownSync(select));
      }

      /**
       * Rebuild sticky length options from the current main form radios,
       * while preserving selected value where possible.
       */
      #refreshLengthDropdownSync(select) {
        if (!select) return;

        const radios = this.#getLengthRadios(select);
        if (!radios.length) return;

        const checkedValue = radios.find((radio) => radio.checked)?.value;
        const currentValue = select.value;
        const nextValues = radios.map((radio) => radio.value);

        select.replaceChildren();
        nextValues.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = this.#abbreviateLengthLabel(value);
          select.append(option);
        });

        const selectedValue = checkedValue
          || (nextValues.includes(currentValue) ? currentValue : nextValues[0]);
        if (selectedValue) {
          select.value = selectedValue;
        }

      }

      /**
       * Abbreviate length option labels for sticky dropdown display.
       * Mirrors snippets/product--length-value-label.liquid for Euro/Norway locales.
       * @param {string} value - Raw option value, e.g. "5 Meter", "10 Metre", "7.5 metri"
       * @returns {string} Abbreviated label such as "5m"
       * @private
       */
      #abbreviateLengthLabel(value) {
        if (typeof value !== 'string') {
          return value;
        }

        // Longer spellings first (Metros before Metro, metres before metre).
        const abbreviated = value
          .replace(' metrów', 'm')
          .replace(' Metrów', 'm')
          .replace(' Metriä', 'm')
          .replace(' metriä', 'm')
          .replace(' Metros', 'm')
          .replace(' metros', 'm')
          .replace(' Metri', 'm')
          .replace(' metri', 'm')
          .replace(' Metres', 'm')
          .replace(' metres', 'm')
          .replace(' Metre', 'm')
          .replace(' metre', 'm')
          .replace(' Meter', 'm')
          .replace(' meter', 'm')
          .replace(' Metro', 'm')
          .replace(' metro', 'm');

        if (abbreviated !== value) {
          // Normalize decimal comma (NO/EU): "5,5 Meter" → "5.5m"
          return abbreviated.replace(/^(\d+),(\d+)m$/u, '$1.$2m');
        }

        const meters = Number.parseFloat(
          value.replace(',', '.').replace(/[^0-9.]/g, '').trim(),
        );
        if (Number.isFinite(meters) && meters > 0) {
          return `${meters}m`;
        }

        return value;
      }

      /**
       * Get length radios associated with sticky dropdown metadata.
       * @param {HTMLSelectElement} select - Sticky length select element.
       * @returns {HTMLInputElement[]} Current length radios in main form.
       */
      #getLengthRadios(select) {
        const { optionName, optionPosition, optionNameAttr } = select.dataset;
        if (!optionName || optionPosition == null || !optionNameAttr) {
          return [];
        }

        const radioName = `${optionName}-${optionPosition}-${optionNameAttr}`;
        const variantRadios = document.querySelector('variant-radios');
        const scopedRadios = variantRadios
          ? Array.from(
              variantRadios.querySelectorAll(
                `input[type="radio"].length-radio[name="${radioName}"]`
              )
            )
          : [];

        if (scopedRadios.length > 0) {
          const currentFormId = scopedRadios[0].getAttribute('form');
          if (currentFormId && select.dataset.formId !== currentFormId) {
            select.dataset.formId = currentFormId;
          }
          return scopedRadios;
        }

        const formId = select.dataset.formId;
        if (!formId) {
          return [];
        }

        return Array.from(
          document.querySelectorAll(
            `input[type="radio"].length-radio[form="${formId}"][name="${radioName}"]`
          )
        );
      }

      /**
       * Bind one change listener for length radios and keep sticky selects in sync.
       */
      #bindLengthRadioListeners() {
        this.#radiosAbortController?.abort();
        this.#radiosAbortController = new AbortController();
        const { signal } = this.#radiosAbortController;
        const variantRadios = document.querySelector('variant-radios');
        if (!variantRadios) return;

        variantRadios.addEventListener('change', (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          if (!target.classList.contains('length-radio')) return;
          if (this.#isSyncingLength) return;
          this.#refreshAllLengthDropdowns();
        }, { signal });
      }

      /**
       * When sticky dropdown changes, check the matching length radio in the main form so variant-radios and slider update.
       */
      #handleDropdownChange(event) {
        const select = event.target;
        const radios = this.#getLengthRadios(select);
        const radio = radios.find((r) => r.value === select.value);
        if (!radio) return;

        this.#isSyncingLength = true;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        this.querySelectorAll('[data-length-dropdown]').forEach((item) => {
          if (item !== select && item.value !== select.value) item.value = select.value;
        });
        this.#isSyncingLength = false;
      }

      /**
       * Sync dropdown selected value from the main form's checked length radio (e.g. when bar becomes visible).
       */
      #syncDropdownFromForm() {
        const selects = Array.from(this.querySelectorAll('[data-length-dropdown]'));
        if (!selects.length) return;
        this.#refreshAllLengthDropdowns();
        selects.forEach((select) => {
          const radios = this.#getLengthRadios(select);
          const checked = radios.find((radio) => radio.checked) || null;
          if (checked && select.value !== checked.value) select.value = checked.value;
        });
      }

      /**
       * Initialize Intersection Observer to watch form wrapper
       */
      #setupObserver() {
        if (!this.#formWrapper) return;

        const options = {
          threshold: 0,
          rootMargin: '0px'
        };

        this.#observer = new IntersectionObserver(
          this.#handleIntersect.bind(this),
          options
        );
        this.#observer.observe(this.#formWrapper);
      }

      /**
       * Hide sticky ATC while the product-page car chooser is on screen.
       */
      #setupFindMyCarObserver() {
        const findMyCarSection = document.querySelector('#find-my-car')
          || document.querySelector('.section-find-my-car');

        if (!findMyCarSection) return;

        this.#findMyCarObserver = new IntersectionObserver(
          ([entry]) => {
            this.#isFindMyCarInView = entry.isIntersecting;
            this.#updateStickyVisibility();
          },
          { threshold: 0 }
        );
        this.#findMyCarObserver.observe(findMyCarSection);
      }

      /**
       * Handle intersection changes
       */
      #handleIntersect(entries) {
        const [entry] = entries;
        const { bottom } = this.#formWrapper.getBoundingClientRect();
        const isFormAboveFold = bottom < 100;

        this.#shouldShowFromForm = !entry.isIntersecting && isFormAboveFold;
        this.#updateStickyVisibility();
      };

      /**
       * Decide whether sticky ATC should be visible.
       */
      #updateStickyVisibility() {
        const shouldShow = this.#shouldShowFromForm
          && !this.#isAtBottom
          && !this.#isFindMyCarInView;

        if (shouldShow) {
          this.#show();
        } else {
          this.#hide();
        }
      }

      /**
       * Show sticky element with animation
       */
      #show() {
        if (this.#isVisible) return;

        this.#stickyElement.classList.remove('translate-y-full', 'opacity-0');
        this.#isVisible = true;
        this.#syncDropdownFromForm();
        this.#syncGlobalStickyState();

        const chatButton = document.getElementById('chat-button');
        if (chatButton) chatButton.style.display = 'none';
      }

      /**
       * Hide sticky element with animation
       */
      #hide() {
        if (!this.#isVisible) return;

        this.#stickyElement.classList.add('translate-y-full', 'opacity-0');
        this.#isVisible = false;
        this.#syncGlobalStickyState();
        
        // Show chat button when sticky ATC is hidden
        const chatButton = document.getElementById('chat-button');
        if (chatButton) {
          chatButton.style.display = '';
        }
      }

      /**
       * Sync sticky ATC visibility and measured height globally.
       */
      #syncGlobalStickyState() {
        if (!this.#stickyElement) return;
        const height = this.#isVisible
          ? Math.max(0, Math.round(this.#stickyElement.getBoundingClientRect().height))
          : 0;
        document.documentElement.style.setProperty('--sticky-atc-height', `${height}px`);
        document.documentElement.toggleAttribute('data-sticky-atc-visible', this.#isVisible);
        document.dispatchEvent(
          new CustomEvent('voldt:sticky-atc-visibility', {
            detail: { visible: this.#isVisible, height }
          })
        );
      }

      /**
       * Handle window scroll events
       */
      #handleScroll() {
        if (!this.#stickyElement) return;

        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const footerHeight = 200; // Approximate footer height
        
        // Check if we're near the bottom (with footer consideration)
        const isAtBottom = (windowHeight + scrollTop) >= (documentHeight - footerHeight);
        
        if (isAtBottom !== this.#isAtBottom) {
          this.#isAtBottom = isAtBottom;
          this.#updateStickyVisibility();
        }
      }

      /**
       * Keep sticky ATC height variable fresh on viewport changes.
       */
      #handleResize() {
        if (!this.#isVisible) return;
        // Avoid layout writes while pinch-zoomed (iOS Safari WebContent OOM risk).
        if (document.documentElement.hasAttribute('data-viewport-zoomed')) return;
        this.#syncGlobalStickyState();
      }
    }
  );
}
})();
(function () {
/**
 * Keep the Trusted Shops / eTrusted floating badge stacked above the sticky ATC bar.
 *
 * The eTrusted app badge injects late and wraps its visible button in a
 * `position: fixed` ancestor with its own stacking context. Putting `z-index`
 * on the button alone does not lift that ancestor, so this module finds the
 * fixed ancestor and marks it.
 *
 * It only ever sets `z-index`. It must never set `transform`/`translate` on that
 * host: the host is an ancestor of the widget's `position: fixed` button, and any
 * non-`none` transform makes it the button's containing block, so the widget's
 * computed `left`/`top` land off-screen and the badge disappears (VOL-82).
 */

const SLOT_ID = 'voldt-trustbadge-slot';
const HOST_ATTR = 'data-voldt-trustbadge-host';
const BADGE_SELECTOR = [
  '[id^="trustbadge-container"]',
  '[data-testid="minimized-trustbadge-floating"]'
].join(',');
const MAX_WAIT_MS = 30000;

let scanQueued = false;
/** @type {WeakSet<HTMLElement>} */
const preparedHosts = new WeakSet();

/**
 * @param {Element|null} el
 * @returns {boolean}
 */
function isReviewsSlotClone(el) {
  return Boolean(el?.closest?.(`#${SLOT_ID}`));
}

/**
 * Walk to the position:fixed ancestor that actually owns viewport placement.
 * @param {Element} el
 * @returns {HTMLElement|null}
 */
function getFixedHost(el) {
  let node = el instanceof HTMLElement ? el : el.parentElement;
  while (node && node !== document.documentElement && node !== document.body) {
    if (window.getComputedStyle(node).position === 'fixed') return node;
    node = node.parentElement;
  }
  return null;
}

function syncHosts() {
  document.querySelectorAll(BADGE_SELECTOR).forEach((el) => {
    if (isReviewsSlotClone(el)) return;
    const host = getFixedHost(el);
    if (!host || preparedHosts.has(host)) return;
    host.setAttribute(HOST_ATTR, '');
    host.style.setProperty('z-index', '240', 'important');
    preparedHosts.add(host);
  });
}

function queueScan() {
  if (scanQueued) return;
  scanQueued = true;
  requestAnimationFrame(() => {
    scanQueued = false;
    syncHosts();
  });
}

queueScan();

if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(() => queueScan());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  // The badge bootstraps within a few seconds; stop watching after that.
  setTimeout(() => observer.disconnect(), MAX_WAIT_MS);
}
})();
(function () {
/**
 * Product gallery media budget for iOS Safari pinch-zoom stability.
 *
 * Horizontal PDP galleries keep many slides in the same vertical viewport band,
 * so native `loading="lazy"` still decodes most of them. Under pinch-zoom Safari
 * re-rasters those bitmaps and commonly OOMs the WebContent process (silent reload).
 *
 * HARD RULES:
 * - Zero visible regression at normal zoom vs staging.
 * - Unzoomed: active ±2 keep full src/srcset; placeholders only further away.
 * - Zoomed (`html[data-viewport-zoomed]`): people zoom to see detail — the
 *   active slide and any slide still on screen must NEVER be downgraded.
 *   Zoom-time savings only for other (offscreen) slides, hidden media, animations.
 * - Count only real slider items (exclude badge overlays / thumbnails).
 *
 * Wired for `electric-slider[data-variant-dynamic="product-slider-main"]`.
 */

/** Adjacent slides kept hot while not pinch-zoomed (visual parity). */
const ACTIVE_RADIUS = 2;
/**
 * Extra neighbor radius while pinch-zoomed (beyond active + on-screen).
 * 0 = do not pre-decode offscreen neighbors; on-screen detection still keeps
 * peeks (e.g. 1.2 slides) at full resolution.
 */
const ACTIVE_RADIUS_ZOOMED = 0;
const LORES_WIDTH = 280;
const LORES_WIDTH_ZOOMED = 160;
const SLIDER_SELECTOR =
  'electric-slider[data-variant-dynamic="product-slider-main"], electric-slider[data-id="product-main-slider"]';

/**
 * @returns {{ radius: number, lores: number, zoomed: boolean }}
 */
function budgetParams() {
  const zoomed = document.documentElement.hasAttribute("data-viewport-zoomed");
  return {
    radius: zoomed ? ACTIVE_RADIUS_ZOOMED : ACTIVE_RADIUS,
    lores: zoomed ? LORES_WIDTH_ZOOMED : LORES_WIDTH,
    zoomed,
  };
}

/**
 * @param {string} url
 * @param {number} width
 * @returns {string}
 */
function withShopifyWidth(url, width) {
  if (!url) return url;
  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set("width", String(width));
    if (parsed.searchParams.has("height")) {
      parsed.searchParams.set("height", String(width));
    }
    return parsed.toString();
  } catch {
    return url
      .replace(/([?&])width=\d+/g, `$1width=${width}`)
      .replace(/([?&])height=\d+/g, `$1height=${width}`);
  }
}

/**
 * @param {HTMLImageElement} img
 */
function ensureImageStore(img) {
  if (img.dataset.pdpBudgetReady === "1") return;
  const fullSrc = img.getAttribute("src") || img.currentSrc || "";
  const fullSrcset = img.getAttribute("srcset") || "";
  img.dataset.pdpFullSrc = fullSrc;
  img.dataset.pdpFullSrcset = fullSrcset;
  const base = fullSrc || fullSrcset.split(/\s/)[0] || "";
  img.dataset.pdpLoresSrc = withShopifyWidth(base, LORES_WIDTH);
  img.dataset.pdpLoresZoomSrc = withShopifyWidth(base, LORES_WIDTH_ZOOMED);
  img.dataset.pdpBudgetReady = "1";
}

/**
 * @param {HTMLElement} slide
 * @param {HTMLElement | null} feed
 * @returns {boolean}
 */
function isSlideOnScreen(slide, feed) {
  if (!feed || typeof slide.getBoundingClientRect !== "function") return false;
  try {
    const fr = feed.getBoundingClientRect();
    const sr = slide.getBoundingClientRect();
    // Any horizontal overlap with the feed viewport = still visible to the user.
    return sr.right > fr.left + 1 && sr.left < fr.right - 1;
  } catch {
    return false;
  }
}

/**
 * @param {HTMLElement} slide
 * @param {boolean} hot
 */
function applySlideBudget(slide, hot) {
  // HARD RULE: never downgrade the active slide — people zoom to see detail.
  if (slide.dataset.active === "true") {
    hot = true;
  }
  slide.querySelectorAll("img").forEach((img) => {
    if (img.closest(".electric-slider__thumbnails")) return;
    if (img.closest("[data-electric-slider-ignore]")) return;
    if (!img.getAttribute("src") && !img.getAttribute("srcset")) return;
    ensureImageStore(img);
    if (hot) {
      if (img.dataset.pdpFullSrcset) {
        img.setAttribute("srcset", img.dataset.pdpFullSrcset);
      }
      if (img.dataset.pdpFullSrc) {
        img.src = img.dataset.pdpFullSrc;
      }
      img.decoding = "async";
    } else {
      const { lores } = budgetParams();
      // Keep full srcset in dataset; strip live srcset so the browser releases decode.
      img.removeAttribute("srcset");
      img.src =
        (lores <= LORES_WIDTH_ZOOMED
          ? img.dataset.pdpLoresZoomSrc
          : img.dataset.pdpLoresSrc) || img.src;
    }
  });

  slide.querySelectorAll("video-player").forEach((player) => {
    if (!(player instanceof HTMLElement)) return;
    if (hot) {
      if (typeof player.load === "function" && player.querySelector("template")) {
        try {
          player.load();
        } catch {
          /* ignore */
        }
      }
      const liveVideo = player.querySelector("video");
      if (liveVideo?.dataset.pdpSrc && !liveVideo.getAttribute("src")) {
        liveVideo.src = liveVideo.dataset.pdpSrc;
        try {
          liveVideo.load();
        } catch {
          /* ignore */
        }
      }
      if (liveVideo?.dataset.pdpWasAutoplay === "1") {
        liveVideo.setAttribute("autoplay", "");
        liveVideo.play?.()?.catch?.(() => {});
      }
      const liveIframe = player.querySelector("iframe");
      if (
        liveIframe instanceof HTMLIFrameElement &&
        liveIframe.dataset.pdpSrc &&
        (!liveIframe.src || liveIframe.src === "about:blank")
      ) {
        liveIframe.src = liveIframe.dataset.pdpSrc;
      }
      return;
    }
    const liveVideo = player.querySelector("video");
    const liveIframe = player.querySelector("iframe");
    if (liveVideo) {
      if (liveVideo.hasAttribute("autoplay") || !liveVideo.paused) {
        liveVideo.dataset.pdpWasAutoplay = "1";
      }
      try {
        liveVideo.pause();
      } catch {
        /* ignore */
      }
      liveVideo.removeAttribute("autoplay");
      if (liveVideo.currentSrc || liveVideo.getAttribute("src")) {
        liveVideo.dataset.pdpSrc =
          liveVideo.currentSrc || liveVideo.getAttribute("src") || "";
        liveVideo.removeAttribute("src");
        try {
          liveVideo.load();
        } catch {
          /* ignore */
        }
      }
    }
    if (
      liveIframe instanceof HTMLIFrameElement &&
      liveIframe.src &&
      liveIframe.src !== "about:blank"
    ) {
      liveIframe.dataset.pdpSrc = liveIframe.src;
      liveIframe.src = "about:blank";
    }
  });

  slide.querySelectorAll("video").forEach((video) => {
    if (video.closest("video-player")) return;
    if (hot) {
      if (video.dataset.pdpSrc && !video.getAttribute("src")) {
        video.src = video.dataset.pdpSrc;
        try {
          video.load();
        } catch {
          /* ignore */
        }
      }
      if (video.dataset.pdpWasAutoplay === "1") {
        video.setAttribute("autoplay", "");
        const playPromise = video.play?.();
        playPromise?.catch?.(() => {});
      }
      return;
    }

    if (video.hasAttribute("autoplay") || !video.paused) {
      video.dataset.pdpWasAutoplay = "1";
    }
    try {
      video.pause();
    } catch {
      /* ignore */
    }
    video.removeAttribute("autoplay");
    if (video.currentSrc || video.getAttribute("src")) {
      video.dataset.pdpSrc = video.currentSrc || video.getAttribute("src") || "";
      video.removeAttribute("src");
      try {
        video.load();
      } catch {
        /* ignore */
      }
    }
  });

  slide.querySelectorAll("iframe").forEach((iframe) => {
    if (iframe.closest("video-player")) return;
    if (hot) {
      if (iframe.dataset.pdpSrc && (!iframe.src || iframe.src === "about:blank")) {
        iframe.src = iframe.dataset.pdpSrc;
      }
      return;
    }
    if (iframe.src && iframe.src !== "about:blank") {
      iframe.dataset.pdpSrc = iframe.src;
      iframe.src = "about:blank";
    }
  });
}

/**
 * Match electric-slider's slide query: exclude badge overlays + thumbnail rail.
 * @param {HTMLElement} slider
 * @returns {HTMLElement[]}
 */
function getSlides(slider) {
  const feed = slider.querySelector(".electric-slider__feed");
  if (!feed) return [];
  const excl = ":not(.electric-slider__thumbnails):not([data-electric-slider-ignore])";
  const nodes = feed.querySelector(":scope > *.contents")
    ? feed.querySelectorAll(`.contents > *${excl}`)
    : feed.querySelectorAll(`:scope > *${excl}`);
  return [...nodes].filter((el) => el.nodeType === Node.ELEMENT_NODE);
}

/**
 * @param {HTMLElement[]} slides
 * @returns {number} marked active index, or -1 if none yet
 */
function getMarkedActiveIndex(slides) {
  return slides.findIndex((slide) => slide.dataset.active === "true");
}

/**
 * Nearest slide to the feed's visual center — used to upgrade before snap settles.
 * @param {HTMLElement} slider
 * @param {HTMLElement[]} slides
 * @returns {number}
 */
function getScrollTargetIndex(slider, slides) {
  const feed = slider.querySelector(".electric-slider__feed");
  if (!feed || !slides.length) return -1;
  const center = feed.scrollLeft + feed.clientWidth / 2;
  let best = 0;
  let bestDist = Infinity;
  slides.forEach((slide, index) => {
    const mid = slide.offsetLeft + slide.offsetWidth / 2;
    const dist = Math.abs(mid - center);
    if (dist < bestDist) {
      bestDist = dist;
      best = index;
    }
  });
  return best;
}

/**
 * @param {HTMLElement} slider
 */
function syncGalleryBudget(slider) {
  if (slider.dataset.pdpBudgetSyncing === "1") return;
  const slides = getSlides(slider);
  if (!slides.length) return;

  const marked = getMarkedActiveIndex(slides);
  // Do not cold anything until the slider has marked an active slide — the first
  // pass used to fall back to 0 and freeze the real first image at lo-res.
  if (marked < 0) return;

  const scrolled = getScrollTargetIndex(slider, slides);
  const { radius, zoomed } = budgetParams();
  const anchors = [marked];
  if (scrolled >= 0 && scrolled !== marked) anchors.push(scrolled);
  const feed = slider.querySelector(".electric-slider__feed");

  slider.dataset.pdpBudgetSyncing = "1";
  try {
    slides.forEach((slide, index) => {
      const isActive = slide.dataset.active === "true";
      const nearAnchor = anchors.some((a) => Math.abs(index - a) <= radius);
      // While zoomed, any slide still on screen stays full-res (not just data-active).
      const onScreen = zoomed && isSlideOnScreen(slide, feed);
      applySlideBudget(slide, isActive || nearAnchor || onScreen);
    });
  } finally {
    slider.dataset.pdpBudgetSyncing = "0";
  }
}

/**
 * Pause / blank far-offscreen UGC iframes. Skips gallery slides (owned by sync).
 * Aggressive blanking of near-viewport media only while pinch-zoomed.
 */
function bindBelowFoldMediaGuard() {
  if (window.__voldtBelowFoldMediaGuardBound) return;
  window.__voldtBelowFoldMediaGuardBound = true;

  if (!("IntersectionObserver" in window)) return;

  const FAR_PX = 400;

  const observer = new IntersectionObserver(
    (entries) => {
      const zoomed = document.documentElement.hasAttribute("data-viewport-zoomed");
      for (const entry of entries) {
        const host = entry.target;
        const iframe = host.querySelector("iframe");
        const video = host.querySelector("video");
        if (entry.isIntersecting) {
          if (iframe?.dataset.pdpSrc && (!iframe.src || iframe.src === "about:blank")) {
            iframe.src = iframe.dataset.pdpSrc;
          }
          if (video?.dataset.pdpSrc && !video.getAttribute("src")) {
            video.src = video.dataset.pdpSrc;
            try {
              video.load();
            } catch {
              /* ignore */
            }
          }
          continue;
        }
        // Far offscreen (invisible) or zoomed: release media. Near-viewport at
        // normal zoom stays loaded for visual parity (media-grid / reviews).
        const rect = host.getBoundingClientRect?.();
        const far =
          !rect ||
          rect.top > window.innerHeight + FAR_PX ||
          rect.bottom < -FAR_PX;
        if (!far && !zoomed) continue;

        if (iframe?.src && iframe.src !== "about:blank") {
          iframe.dataset.pdpSrc = iframe.src;
          iframe.src = "about:blank";
        }
        if (video && !video.paused) {
          try {
            video.pause();
          } catch {
            /* ignore */
          }
        }
      }
    },
    { rootMargin: "400px 0px", threshold: 0.01 },
  );

  const targets = document.querySelectorAll(
    "video-player, .shopify-section iframe[src*='youtube'], .shopify-section iframe[src*='vimeo']",
  );

  targets.forEach((el) => {
    if (el.closest(SLIDER_SELECTOR)) return;
    const host = el.tagName === "IFRAME" ? el.parentElement || el : el;
    const rect = host.getBoundingClientRect?.() || el.getBoundingClientRect();
    const iframe = host.querySelector?.("iframe") || (el.tagName === "IFRAME" ? el : null);
    // Only eager-blank media that is already far below the fold (invisible).
    if (iframe && rect.top > window.innerHeight + FAR_PX) {
      if (iframe.src && iframe.src !== "about:blank") {
        iframe.dataset.pdpSrc = iframe.src;
        iframe.src = "about:blank";
      }
    }
    const video = host.querySelector?.("video");
    if (video && rect.top > window.innerHeight + FAR_PX && !video.paused) {
      try {
        video.pause();
      } catch {
        /* ignore */
      }
    }
    observer.observe(host);
  });
}

function bindProductGalleryMediaBudget() {
  if (window.__voldtProductGalleryMediaBudgetBound) return;
  window.__voldtProductGalleryMediaBudgetBound = true;

  const attach = (slider) => {
    if (!(slider instanceof HTMLElement) || slider.dataset.pdpBudgetBound === "1") return;
    slider.dataset.pdpBudgetBound = "1";

    const schedule = () => {
      requestAnimationFrame(() => syncGalleryBudget(slider));
    };

    schedule();
    slider.addEventListener("electric-slider:index-change", schedule);

    const feed = slider.querySelector(".electric-slider__feed");
    feed?.addEventListener("scroll", schedule, { passive: true });
    feed?.addEventListener("scrollend", schedule, { passive: true });

    // Re-sync when data-active flips (electric-slider may set it without the event
    // on first paint) and when variant swaps replace children.
    const mo = new MutationObserver(schedule);
    mo.observe(slider, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-active"],
    });

    customElements.whenDefined("electric-slider").then(schedule);
  };

  const scan = () => {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(attach);
  };

  scan();
  document.addEventListener("shopify:section:load", scan);
  window.addEventListener("voldt:viewport-zoom", () => {
    document.querySelectorAll(SLIDER_SELECTOR).forEach((slider) => syncGalleryBudget(slider));
  });

  bindBelowFoldMediaGuard();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindProductGalleryMediaBudget, { once: true });
} else {
  bindProductGalleryMediaBudget();
}
})();
